// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin dashboard styling aligned with the site's gradient/glass look */
.admin-page {
  background: transparent;
  padding: 0;
  border-radius: 0;
  box-shadow: none;
  animation: none;
  color: var(--text-primary);
}

.admin-hero {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  align-items: stretch;
  margin-bottom: 0px;
}

.admin-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 0px;
}

@media (max-width: 900px) {
  .admin-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .admin-stats-grid {
    grid-template-columns: 1fr;
  }
}

/* Admin layout: 3 columns (Sidebar, Content, Stats Sidebar) */
.admin-dashboard-root .user-profile-dashboard {
  grid-template-columns: 280px 1fr 240px !important;
  gap: 20px !important;
}

@media (max-width: 1400px) {
  .admin-dashboard-root .user-profile-dashboard {
    grid-template-columns: 260px 1fr 220px !important;
    gap: 12px !important;
  }
}

@media (max-width: 1100px) {
  .admin-dashboard-root .user-profile-dashboard {
    grid-template-columns: 240px 1fr !important;
  }
}

/* Overriding global bento gaps for Admin */
.admin-dashboard-root.user-details-page {
  padding-top: 0 !important;
}

.admin-dashboard-root .user-profile-dashboard {
  grid-template-columns: 280px 1fr 240px !important;
}

.admin-dashboard-root .user-profile-dashboard .bento-grid-layout {
  grid-template-columns: repeat(2, 1fr) !important;
  gap: 12px !important;
}

.admin-dashboard-root .user-profile-dashboard.no-stats {
  grid-template-columns: 280px 1fr !important;
}

.admin-dashboard-root .user-profile-dashboard .profile-dashboard-main {
  gap: 12px !important;
}

/* Recharts + backdrop-filter + transform на bento дают «белую плашку» после быстрого скролла (слой не перерисовывается) */
.admin-dashboard-root .profile-dashboard-main .bento-card {
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

[data-theme='dark'] .admin-dashboard-root .profile-dashboard-main .bento-card {
  background: var(--bg-secondary);
}

.admin-dashboard-root .profile-dashboard-main .bento-card:hover {
  transform: none;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.08);
}

[data-theme='dark'] .admin-dashboard-root .profile-dashboard-main .bento-card:hover {
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);
}

.admin-dashboard-root .profile-dashboard-main .admin-chart-slot {
  position: relative;
  isolation: isolate;
}

.admin-hero-text {
  padding: 24px;
  border-radius: 18px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.admin-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--nav-active-color);
  background: var(--nav-active-bg);
  border-radius: 999px;
  letter-spacing: 0.01em;
}

.admin-title {
  margin: 16px 0 10px;
  font-size: 2.4rem;
  font-weight: 700;
  line-height: 1.2;
  color: var(--text-primary);
  letter-spacing: -0.015em;
}

.admin-subtitle {
  color: var(--text-secondary);
  font-size: 1.05rem;
  margin-bottom: 18px;
}

.admin-cta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.admin-btn {
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.admin-btn.primary {
  color: #fff;
  background: var(--accent-color);
  box-shadow: var(--shadow-sm);
}

.admin-btn.primary:hover {
  background: var(--accent-hover);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.admin-btn.ghost {
  color: var(--text-primary);
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
}

.admin-btn.ghost:hover {
  background: var(--nav-hover-bg);
  transform: translateY(-2px);
}

.admin-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #64748b;
  font-size: 0.95rem;
}

/* Premium Card Design */
.admin-card-premium {
  background: var(--bg-glass-heavy);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--border-glass);
  border-radius: 16px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px -1px rgba(0, 0, 0, 0.01);
  overflow: hidden;
  position: relative;
}

.admin-card-premium:hover {
  /* Hover zoom disabled as requested */
  transform: none;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px -1px rgba(0, 0, 0, 0.01);
  border-color: var(--border-glass);
}

.admin-card-premium .card-header {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: none !important;
}

.admin-card-premium .card-divider {
  height: 1px;
  width: 100%;
  border-top: 1px dashed rgba(255, 255, 255, 0.15);
  margin: 1px 0;
  opacity: 0.5;
}

[data-theme='light'] .admin-card-premium .card-divider {
  border-top: 1px dashed rgba(0, 0, 0, 0.08);
}


.admin-card-premium .card-title {
  color: var(--text-secondary);
  font-size: 0.8125rem;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

/* Period Selector Styles */
.period-selector {
  display: flex;
  background: rgba(0, 0, 0, 0.04);
  padding: 2px;
  border-radius: 8px;
  gap: 1px;
  flex-shrink: 0;
}

.period-selector.vertical {
  flex-direction: column;
  padding: 1px;
  gap: 2px;
}

.period-selector.vertical .period-pill {
  padding: 4px 2px;
  min-width: 18px;
}

[data-theme='dark'] .period-selector {
  background: rgba(255, 255, 255, 0.05);
}

.period-pill {
  border: none;
  background: transparent;
  padding: 3px 6px;
  font-size: 0.65rem;
  font-weight: 700;
  color: var(--text-secondary);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 20px;
  text-align: center;
}

.period-pill:hover {
  color: var(--text-primary);
  background: rgba(0, 0, 0, 0.05);
}

.period-pill.active {
  background: white;
  color: var(--accent-color);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

[data-theme='dark'] .period-pill.active {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}


.admin-card-premium .card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* Vertical centering */
  justify-content: flex-start;
  gap: 16px;
  width: 100%;
}

.admin-card-metrics-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex: 1 1;
}

.admin-card-premium .card-value {
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.04em;
  margin: 0;
  line-height: 1.1;
  text-align: center;
  width: auto;
}

.admin-card-premium .card-trend {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 700;
  background: rgba(16, 185, 129, 0.12);
  color: #10b981;
  align-self: center;
  /* Ensure it centers in flex column */
}

.admin-card-premium .card-trend.negative {
  background: rgba(239, 68, 68, 0.12);
  color: #ef4444;
}

/* Fix icon spacing in trend badges */
.admin-card-premium .card-trend svg {
  margin-right: 6px !important;
}


.admin-card-premium .icon-circle-premium {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04), inset 0 0 0 1px rgba(0, 0, 0, 0.02);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.admin-card-premium:hover .icon-circle-premium {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04), inset 0 0 0 1px rgba(0, 0, 0, 0.02);
}

.admin-dot {
  width: 6px;
  height: 6px;
  background: #c084fc;
  border-radius: 50%;
  display: inline-flex;
}

/* Push notifications: centered hero (no aside card) */
.admin-notifications-hero--centered {
  grid-template-columns: 1fr;
  justify-items: stretch;
}

/* «Назад» внутри той же карточки hero, без сдвига центрального блока */
.admin-notifications-hero-text.admin-hero-text {
  position: relative;
  text-align: center;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
}

.admin-notifications-hero-back {
  position: absolute;
  z-index: 2;
  top: 20px;
  inset-inline-start: 20px;
  margin: 0;
  max-width: min(13rem, 42%);
  white-space: normal;
  text-align: start;
  line-height: 1.25;
  hyphens: auto;
}

.profile-stats-sidebar {
  padding-top: 0;
}

.admin-stats-strip {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 20px;
  width: 100%;
}

.admin-status-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background: var(--bg-glass-heavy);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--border-glass);
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
}

.admin-status-badge:hover {
  transform: translateY(-2px);
  border-color: var(--accent-primary);
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);
}

.admin-status-badge .stat-label {
  display: flex;
  align-items: center;
  color: var(--text-secondary);
}

.admin-status-badge .stat-value {
  color: var(--text-primary);
  font-weight: 700;
  margin-left: 4px;
}

@media (max-width: 520px) {
  .admin-notifications-hero-back {
    position: static;
    align-self: flex-start;
    margin: 0 0 10px;
    max-width: 100%;
    white-space: normal;
    text-align: start;
  }
}

.admin-notifications-hero--centered .admin-subtitle {
  max-width: 36rem;
  margin-left: auto;
  margin-right: auto;
}

.admin-notifications-hero--centered .admin-cta {
  justify-content: center;
}

.admin-notifications-hero--centered .admin-meta {
  justify-content: center;
  flex-wrap: wrap;
}

.admin-hero-card {
  border-radius: 18px;
  padding: 20px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
  position: relative;
  overflow: hidden;
}

.admin-hero-card::after {
  content: '';
}

.hero-card-row {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 16px;
  position: relative;
  z-index: 1;
}

.hero-metric {
  display: grid;
  gap: 6px;
}

.metric-label {
  color: #cbd5e1;
  font-size: 0.95rem;
}

.metric-value {
  font-size: 2.1rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #fff;
}

.metric-value.small {
  font-size: 1.6rem;
}

.metric-trend {
  font-size: 0.9rem;
  font-weight: 700;
  padding: 6px 10px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  width: fit-content;
}

.metric-trend.up {
  background: rgba(16, 185, 129, 0.16);
  color: #34d399;
}

.metric-trend.neutral {
  background: rgba(148, 163, 184, 0.2);
  color: #cbd5e1;
}

.hero-divider {
  width: 1px;
  height: 100%;
  background: linear-gradient(180deg, transparent, rgba(226, 232, 240, 0.65), transparent);
}

.hero-quick {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.mini-metric {
  background: var(--bg-primary);
  border-radius: 14px;
  padding: 12px 14px;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

/* Removed duplicate .admin-stats-grid */

.admin-form-card {
  margin-bottom: 18px;
  padding: 18px;
  border-radius: 16px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.admin-form-card .panel-title {
  margin: 4px 0 0;
}

.form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.admin-form {
  display: grid;
  gap: 12px;
}

/* Push notifications: compact layout, sections, responsive columns */
.admin-notifications-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.admin-notifications-card.admin-form-card {
  padding: 14px 16px 16px;
}

.admin-notifications-inner {
  max-width: min(880px, 100%);
  margin-inline: auto;
}

.admin-notifications-form {
  gap: 10px;
}

.admin-notifications-form-header.form-header {
  align-items: flex-start;
  margin-bottom: 10px;
  gap: 10px 18px;
  flex-wrap: wrap;
}

.admin-notifications-section {
  display: grid;
  gap: 10px;
}

.admin-notifications-section--technical {
  padding-top: 12px;
  margin-top: 4px;
  border-top: 1px dashed rgba(148, 163, 184, 0.5);
}

.admin-notifications-section-kicker {
  margin: 0 0 2px;
  font-size: 0.95rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #64748b;
}

.admin-notifications-top-grid {
  display: grid;
  grid-template-columns: 1fr minmax(0, 220px);
  gap: 10px 14px;
  align-items: end;
}

.admin-notifications-meta-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px 14px;
  align-items: end;
}

@media (min-width: 720px) {
  .admin-notifications-meta-row {
    grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);
  }
}

.admin-notifications-technical-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px 14px;
  align-items: end;
}

@media (min-width: 720px) {
  .admin-notifications-technical-grid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}

.admin-notifications-technical-field {
  margin: 0;
}

.admin-notifications-form .form-field textarea {
  padding: 12px;
  border-radius: 10px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  background: var(--bg-primary);
  font-size: 1rem;
  font-family: inherit;
  line-height: 1.45;
  color: #0f172a;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
  box-sizing: border-box;
}

.admin-notifications-form .form-field textarea:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.18);
}

.admin-notifications-textarea--description {
  resize: vertical;
  min-height: 4.75rem;
}

.admin-notifications-textarea--ids {
  resize: vertical;
  min-height: 5.5rem;
  font-family: ui-monospace, 'Cascadia Code', 'Consolas', monospace;
  font-size: 1rem;
}

@media (max-width: 560px) {
  .admin-notifications-top-grid {
    grid-template-columns: 1fr;
  }
}

/* Notifications: header actions (save toggle) */
.admin-notifications-header-actions {
  display: grid;
  justify-items: end;
  gap: 6px;
  min-width: 260px;
}

.admin-notifications-save-pill {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 999px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.admin-notifications-save-pill-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

/* Removed duplicate .card-icon-circle */

.admin-notifications-save-pill-ui {
  width: 38px;
  height: 22px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.35);
  border: 1px solid rgba(148, 163, 184, 0.55);
  position: relative;
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  flex-shrink: 0;
}

.admin-notifications-save-pill-ui::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--bg-primary);
  transform: translateY(-50%);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.14);
  transition: left 0.22s ease;
}

.admin-notifications-save-pill-input:checked+.admin-notifications-save-pill-ui {
  background: linear-gradient(135deg, #0ea5e9 0%, #6366f1 100%);
  border-color: rgba(99, 102, 241, 0.65);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.16);
}

.admin-notifications-save-pill-input:checked+.admin-notifications-save-pill-ui::after {
  left: 18px;
}

.admin-notifications-save-pill-text {
  font-weight: 700;
  color: #0c4a6e;
  font-size: 0.9rem;
  line-height: 1.1;
}

.admin-notifications-save-pill-hint {
  font-size: 0.78rem;
  color: #0369a1;
  font-weight: 600;
  text-align: right;
  max-width: 420px;
}

@media (max-width: 768px) {
  .admin-notifications-header-actions {
    justify-items: start;
    min-width: 0;
  }

  .admin-notifications-save-pill-hint {
    text-align: left;
  }
}

/* Notifications: result card */
.admin-notifications-result {
  margin-top: 16px;
  padding: 16px;
  background: rgba(99, 102, 241, 0.08);
  border-radius: 12px;
  border: 1px solid rgba(99, 102, 241, 0.2);
}

.admin-notifications-result-title {
  margin: 0 0 8px;
  font-weight: 800;
  color: #0f172a;
}

.admin-notifications-result-text {
  margin: 0;
  color: #475569;
  font-weight: 600;
}

/* Push notifications: role + open page selects */
.admin-notifications-role-select,
.admin-notifications-open-page-select {
  width: 100%;
  max-width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(99, 102, 241, 0.22);
  background: var(--bg-secondary);
  font-size: 0.98rem;
  font-weight: 600;
  color: #0f172a;
  cursor: pointer;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  appearance: auto;
}

.admin-notifications-open-page-select {
  min-height: 48px;
}

.admin-notifications-role-select:hover,
.admin-notifications-open-page-select:hover {
  border-color: rgba(99, 102, 241, 0.45);
  background: var(--bg-primary);
}

.admin-notifications-role-select:focus,
.admin-notifications-open-page-select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

.admin-notifications-platform-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
}

.admin-notifications-platform-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 10px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: var(--bg-primary);
  font-weight: 600;
  font-size: 0.9rem;
  color: #334155;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.admin-notifications-platform-item:focus-within {
  border-color: #6366f1;
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.15);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.form-field {
  display: grid;
  gap: 6px;
  font-size: 0.95rem;
  color: #475569;
}

.form-field input,
.form-field select {
  padding: 12px;
  border-radius: 10px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  background: var(--bg-primary);
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-field input:focus,
.form-field select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.18);
}

.form-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

.form-status {
  padding: 12px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.95rem;
}

.form-status.success {
  background: rgba(16, 185, 129, 0.12);
  color: #0f9f6e;
  border: 1px solid rgba(16, 185, 129, 0.3);
}

.form-status.error {
  background: rgba(239, 68, 68, 0.12);
  color: #b91c1c;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.admin-form-optional {
  font-weight: 500;
  font-size: 0.75rem;
  color: var(--text-secondary, #64748b);
  text-transform: none;
  letter-spacing: normal;
}

.admin-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 2000;
}

.admin-modal {
  width: min(480px, 100%);
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.25);
  border: 1px solid rgba(226, 232, 240, 0.9);
}

.admin-notifications-confirm-backdrop {
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.admin-notifications-confirm-modal {
  width: min(760px, calc(100vw - 32px));
  max-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
  padding: 22px;
}

.admin-notifications-confirm-modal .modal-header {
  margin-bottom: 14px;
}

.admin-notifications-confirm-modal .modal-body {
  margin-bottom: 16px;
  overflow-y: auto;
  max-height: calc(100vh - 220px);
  padding-right: 4px;
}

.admin-notifications-confirm-modal .confirm-list {
  gap: 8px;
}

.admin-notifications-confirm-modal .confirm-list li {
  padding: 12px 14px;
}

.admin-notifications-confirm-modal .modal-actions {
  margin-top: auto;
}

@media (max-width: 768px) {
  .admin-notifications-confirm-modal {
    width: min(680px, calc(100vw - 24px));
    max-height: calc(100vh - 24px);
    padding: 18px;
  }

  .admin-notifications-confirm-modal .modal-body {
    max-height: calc(100vh - 200px);
  }
}

@media (max-width: 480px) {
  .admin-notifications-confirm-backdrop {
    padding: 10px;
  }

  .admin-notifications-confirm-modal {
    width: 100%;
    max-height: calc(100vh - 20px);
    padding: 14px;
    border-radius: 12px;
  }

  .admin-notifications-confirm-modal .modal-actions {
    flex-direction: column;
    align-items: stretch;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.modal-body {
  margin-bottom: 14px;
  color: #475569;
}

.confirm-list {
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
  display: grid;
  gap: 6px;
}

.confirm-list li {
  background: var(--bg-primary);
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(226, 232, 240, 0.8);
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

/* Кнопки подтверждения в модалке админки (нужен базовый .btn из user-details.css + донастройка) */
.admin-modal .admin-modal-actions {
  gap: 12px;
  margin-top: 8px;
  padding-top: 4px;
}

.admin-modal .admin-modal-actions .admin-modal-btn-cancel,
.admin-modal .admin-modal-actions .admin-modal-btn-submit {
  min-height: 44px;
  padding: 12px 22px;
  border-radius: 12px;
  font-size: 0.9375rem;
  font-weight: 700;
}

.admin-modal .admin-modal-actions .admin-modal-btn-cancel {
  background: var(--bg-secondary, #f1f5f9);
  color: var(--text-primary, #0f172a);
  border: 1px solid var(--border-color, #e2e8f0);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.admin-modal .admin-modal-actions .admin-modal-btn-cancel:hover:not(:disabled) {
  background: var(--bg-primary, #fff);
  border-color: var(--accent-primary, #3b82f6);
  color: var(--accent-primary, #3b82f6);
}

.admin-modal .admin-modal-actions .admin-modal-btn-submit {
  background: linear-gradient(180deg, #3b82f6 0%, #2563eb 100%);
  color: #fff;
  border: none;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.35);
}

.admin-modal .admin-modal-actions .admin-modal-btn-submit:hover:not(:disabled) {
  background: linear-gradient(180deg, #2563eb 0%, #1d4ed8 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.4);
}

.admin-modal .admin-modal-actions .admin-modal-btn-submit:focus-visible {
  outline: 2px solid #93c5fd;
  outline-offset: 2px;
}

.admin-modal .admin-modal-actions .admin-modal-btn-cancel:focus-visible {
  outline: 2px solid var(--accent-primary, #3b82f6);
  outline-offset: 2px;
}

[data-theme='dark'] .admin-modal .admin-modal-actions .admin-modal-btn-cancel {
  background: rgba(30, 41, 59, 0.9);
  border-color: rgba(148, 163, 184, 0.25);
  color: var(--text-primary, #f1f5f9);
}

[data-theme='dark'] .admin-modal .admin-modal-actions .admin-modal-btn-cancel:hover:not(:disabled) {
  border-color: #60a5fa;
  color: #93c5fd;
}

.admin-card {
  display: flex;
  gap: 14px;
  padding: 18px;
  border-radius: 16px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.admin-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-md);
}

.admin-card .card-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text-primary);
  flex-shrink: 0;
}

.admin-card.accent-blue .card-icon {
  background: rgba(79, 70, 229, 0.15);
  color: #4F46E5;
  box-shadow: none;
}

.admin-card.accent-purple .card-icon {
  background: rgba(124, 58, 237, 0.15);
  color: #7c3aed;
  box-shadow: none;
}

.admin-card.accent-green .card-icon {
  background: rgba(16, 185, 129, 0.15);
  color: #10b981;
  box-shadow: none;
}

.card-body {
  display: grid;
  gap: 8px;
}

.card-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
}

.card-text {
  color: var(--text-secondary);
  font-size: 0.96rem;
}

.card-link {
  font-weight: 700;
  color: var(--accent-color);
  font-size: 0.95rem;
}

.admin-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}

.admin-panel {
  background: var(--bg-secondary);
  border-radius: 14px;
  border: 1px solid var(--border-color);
  padding: 20px;
  box-shadow: var(--shadow-sm);
  width: 100%;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.panel-label {
  color: #94a3b8;
  font-size: 0.8rem;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.panel-title {
  margin: 4px 0 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
}

.pill {
  padding: 6px 14px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.85rem;
}

.pill-green {
  background: rgba(16, 185, 129, 0.12);
  color: #10b981;
}

.pill-blue {
  background: rgba(59, 130, 246, 0.12);
  color: #2563eb;
}

.panel-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 10px;
}

.panel-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid var(--border-color);
  background: var(--bg-primary);
}

.item-title {
  margin: 0;
  font-weight: 700;
  color: var(--text-primary);
}

.item-text {
  margin: 4px 0 0;
  color: var(--text-secondary);
  font-size: 0.95rem;
}

.item-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-flex;
}

.status-dot.success {
  background: #22c55e;
}

.status-dot.warning {
  background: #f59e0b;
}

.status-dot.info {
  background: #3b82f6;
}

.health-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
  margin-bottom: 12px;
}

.health-card {
  border-radius: 12px;
  padding: 12px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.health-card .item-title {
  font-size: 0.98rem;
}

.health-value {
  margin: 6px 0;
  font-size: 1.5rem;
  font-weight: 800;
}

.health-card .metric-trend {
  margin-top: 4px;
}

.health-card.tone-blue .health-value {
  color: #2563eb;
}

.health-card.tone-purple .health-value {
  color: #7c3aed;
}

.health-card.tone-green .health-value {
  color: #059669;
}

.updates {
  border-top: 1px solid rgba(226, 232, 240, 0.9);
  padding-top: 12px;
}

.updates-title {
  margin: 0 0 8px;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.updates-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 10px;
}

.updates-item {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
}

.item-badge {
  align-self: center;
  padding: 6px 10px;
  border-radius: 10px;
  background: rgba(79, 70, 229, 0.15);
  color: #4F46E5;
  font-weight: 700;
  font-size: 0.9rem;
}

@media (max-width: 1024px) {
  .admin-hero {
    grid-template-columns: 1fr;
  }
}

/* Category Stats Styles */
.category-stats-container {
  margin-top: 12px;
}

.admin-category-stats-bento {
  overflow: visible;
}

.admin-category-stats-bento .admin-category-stats-panel {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 8px 8px 4px;
}

.category-stats-chart-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
}

.category-stats-full-list {
  width: 100%;
  max-width: 560px;
}

.category-stats-full-list-heading {
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--text-secondary, #64748b);
  margin: 0 0 12px;
  text-align: center;
}

.category-stats-full-list-ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.category-stats-full-list-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  background: var(--bg-primary, #fff);
  border: 1px solid var(--border-color, rgba(226, 232, 240, 0.85));
}

.category-stats-full-list-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.06);
}

.category-stats-full-list-name {
  flex: 1 1;
  min-width: 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary, #1e293b);
  line-height: 1.35;
  word-break: break-word;
}

.category-stats-full-list-count {
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--accent-color, #6366f1);
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}

.category-stats-donut-wrap--interactive {
  cursor: crosshair;
}

.category-stats-donut-tooltip {
  pointer-events: none;
  padding: 10px 12px;
  border-radius: 10px;
  background: #1e293b;
  color: #f8fafc;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.35);
  max-width: 260px;
}

.category-stats-donut-tooltip-title {
  font-weight: 700;
  font-size: 0.88rem;
  margin-bottom: 4px;
  color: #fff;
  line-height: 1.3;
}

.category-stats-donut-tooltip-count {
  font-size: 0.78rem;
  color: #94a3b8;
}

.category-stats-donut-wrap {
  position: relative;
  width: 200px;
  height: 200px;
  flex-shrink: 0;
}

.category-stats-donut-ring {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  box-shadow: 0 8px 28px rgba(99, 102, 241, 0.2);
}

.category-stats-donut-ring--empty {
  background: conic-gradient(#e2e8f0 0% 100%);
  opacity: 0.85;
}

.category-stats-donut-hole {
  position: absolute;
  inset: 18%;
  border-radius: 50%;
  background: linear-gradient(160deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid rgba(226, 232, 240, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 8px;
  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.9);
  pointer-events: none;
}

.category-stats-donut-total {
  font-size: 1.75rem;
  font-weight: 800;
  color: #1e293b;
  line-height: 1.1;
  letter-spacing: -0.02em;
}

.category-stats-donut-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-top: 4px;
}

.category-stats-legend {
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 320px;
  overflow-y: auto;
}

.category-stats-legend-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid rgba(226, 232, 240, 0.85);
}

.category-stats-legend-swatch {
  width: 12px;
  height: 12px;
  border-radius: 4px;
  flex-shrink: 0;
  margin-top: 4px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
}

.category-stats-legend-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.35;
  word-break: break-word;
}

.category-stats-legend-meta {
  font-size: 0.8rem;
  font-weight: 700;
  color: #6366f1;
}

.category-stats-list {
  display: grid;
  gap: 10px;
}

.category-stat-item {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 14px 16px;
  transition: all 0.25s ease;
  position: relative;
  overflow: hidden;
}

.category-stat-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: var(--accent-color);
  opacity: 0;
  transition: opacity 0.25s ease;
}

.category-stat-item:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-sm);
  border-color: #3f3f46;
}

.category-stat-item:hover::before {
  opacity: 1;
}

.category-stat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.category-stat-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
  flex: 1 1;
  line-height: 1.4;
}

.category-stat-count {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--accent-color);
  margin-left: 12px;
}

.category-stat-bar-container {
  width: 100%;
  height: 6px;
  background: var(--bg-secondary);
  border-radius: 999px;
  overflow: hidden;
  margin-bottom: 8px;
  position: relative;
}

.category-stat-bar {
  height: 100%;
  background: var(--accent-color);
  border-radius: 999px;
  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none;
}

.category-stat-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.8rem;
}

.category-stat-percentage {
  font-weight: 700;
  color: #475569;
  font-size: 0.85rem;
}

.category-stat-label {
  color: #94a3b8;
  font-size: 0.8rem;
}

.category-stats-loading,
.category-stats-error,
.category-stats-empty {
  padding: 32px 20px;
  text-align: center;
  color: #64748b;
  font-size: 0.9rem;
}

.category-stats-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--border-color);
  border-top-color: #6366f1;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.category-stats-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.error-message {
  color: #ef4444;
  font-weight: 600;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .admin-page {
    padding: 18px;
  }

  .admin-columns {
    grid-template-columns: 1fr;
  }

  .panel-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .item-meta {
    width: 100%;
    justify-content: space-between;
  }

  .category-stat-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .category-stat-count {
    font-size: 0.9rem;
  }

  /* =========================================
   NEW ADMIN DASHBOARD STYLES (CHARTS & FORM)
   ========================================= */

  /* Header Actions */
  .admin-header-actions {
    display: flex;
    gap: 16px;
    align-items: center;
    flex-wrap: wrap;
  }

  .admin-header-actions .orders-pager-nav {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border-radius: 8px;
  }

  .admin-quick-metrics {
    display: flex;
    gap: 12px;
    margin-right: 8px;
  }

  .metric-badge-blue {
    color: var(--accent-primary, #2563eb) !important;
    background: rgba(37, 99, 235, 0.1) !important;
    border: none !important;
    padding: 6px 12px !important;
  }

  .metric-badge-blue i,
  .metric-badge-blue svg {
    margin-right: 6px;
  }

  .metric-badge-green {
    color: var(--accent-success, #10b981) !important;
    background: rgba(16, 185, 129, 0.1) !important;
    border: none !important;
    padding: 6px 12px !important;
  }

  .metric-badge-green i,
  .metric-badge-green svg {
    margin-right: 6px;
  }

  /* Expandable Form */
  .admin-form-panel {
    background: var(--bg-secondary, #ffffff);
    border: 1px solid var(--border-color, #e5e7eb);
    border-radius: 12px;
    padding: 20px;
    margin-top: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  }

  .admin-form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 16px;
  }

  .admin-form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .admin-form-group label {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--text-secondary, #64748b);
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  .admin-form-group input,
  .admin-form-group select {
    width: 100%;
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid var(--border-color, #cbd5e1);
    background: var(--bg-primary, #ffffff);
    font-size: 0.95rem;
    color: var(--text-primary);
    outline: none;
    transition: all 0.2s ease;
    box-sizing: border-box;
  }

  .admin-form-group input:focus,
  .admin-form-group select:focus {
    border-color: var(--accent-primary, #2563eb);
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
  }

  .admin-form-actions {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
  }

  /* Charts Grid */
  .admin-charts-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
    gap: 24px;
    padding-bottom: 24px;
  }

  .admin-chart-card {
    background: var(--bg-secondary, #ffffff);
    border-radius: 16px;
    padding: 24px;
    border: 1px solid var(--border-color, #e5e7eb);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    display: flex;
    flex-direction: column;
  }

  .admin-chart-title {
    margin: 0 0 24px 0;
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--text-primary);
  }

  .admin-chart-container {
    width: 100%;
    height: 320px;
  }

  /* Custom Recharts Tooltip */
  .admin-chart-tooltip {
    background: var(--bg-secondary, #ffffff) !important;
    padding: 12px 16px !important;
    border: 1px solid var(--border-color, #e5e7eb) !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 12px -2px rgba(0, 0, 0, 0.08) !important;
  }

  .admin-chart-tooltip .tooltip-title {
    margin: 0;
    font-weight: 600;
    color: var(--text-primary);
    font-size: 0.95rem;
  }

  .admin-chart-tooltip .tooltip-value {
    margin: 4px 0 0;
    font-size: 0.9rem;
  }

  .admin-chart-tooltip .tooltip-value span {
    font-weight: 700;
  }

  @media (max-width: 768px) {
    .admin-header-actions {
      flex-direction: column;
      align-items: stretch;
    }

    .admin-charts-grid {
      grid-template-columns: 1fr;
    }
  }
}

/* Updated Status Metrics Card */
.admin-status-card-new {
  background: var(--bg-glass-heavy);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid var(--border-glass);
  border-radius: 20px;
  padding: 16px;
  width: 100%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.admin-status-card-new .status-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  justify-content: space-between;
}

.admin-status-card-new .status-row .custom-icon {
  color: var(--accent-primary);
  opacity: 0.9;
  flex-shrink: 0;
  /* Prevent icon from shrinking */
}

.admin-status-card-new .status-label {
  font-family: var(--font-heading);
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  flex: 1 1;
}

.admin-status-card-new .status-value {
  font-family: var(--font-data);
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--text-primary);
  text-align: right;
  white-space: nowrap;
  /* Prevent value from wrapping */
}

.admin-status-card-new .status-divider {
  height: 1px;
  width: 100%;
  border-top: 1px dashed var(--border-color);
  opacity: 0.3;
}

[data-theme='dark'] .admin-status-card-new .status-divider {
  opacity: 0.15;
}

/* Global Page Entry Animation */
.user-details-page {
  animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Disable hover effects for Create Employee tab as requested */
.admin-create-employee-card:hover {
  transform: none !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.03) !important;
}

.admin-create-employee-card .btn:hover {
  transform: none !important;
}

/* Sidebar Metrics Alignment & Spacing */
.profile-sidebar-metrics {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
  width: 100%;
}

/* Premium Form Styles */
.premium-form-card {
  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.05);
}

.card-content-rows {
  display: flex;
  flex-direction: column;
}

.form-row-premium {
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.4);
}

.form-row-premium.horizontal {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.row-label-caps {
  font-size: 0.75rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  width: 140px;
  flex-shrink: 0;
}

.row-value-right {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.premium-input-minimal {
  width: 100%;
  background: rgba(248, 250, 252, 0.6);
  border: 1px solid rgba(226, 232, 240, 0.8);
  padding: 10px 14px 10px 40px;
  border-radius: 12px;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text-primary);
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.premium-input-minimal:focus {
  background: white;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.admin-create-employee-card .premium-input-wrapper:not(.premium-input-wrapper--password-toggle) .premium-input-minimal {
  padding-top: 12px;
  padding-bottom: 12px;
}

.btn-premium-action-new {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 32px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 14px;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.btn-premium-action-new:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.35);
  background: #2563eb;
}

.btn-premium-action-new:active {
  transform: translateY(0);
}

.btn-premium-action-new:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);
}

.btn-inner-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
}

.form-grid-premium {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.form-group-premium {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group-premium.full-width {
  grid-column: span 2;
}

.premium-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.premium-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

/* Высота строки как у .premium-select-trigger (12px по вертикали), глаз компактнее и чуть ниже оптического центра как у стрелки роли */
.premium-input-wrapper--password-toggle .premium-input-minimal {
  padding: 12px 44px 12px 40px;
}

.premium-input-wrapper--password-toggle .password-toggle {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(calc(-50% + 2px));
  color: #94a3b8;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
}

.premium-input-wrapper--password-toggle .password-toggle:hover {
  color: var(--text-main);
}

.premium-input-icon {
  position: absolute;
  left: 14px;
  color: var(--text-secondary);
  opacity: 0.5;
  transition: all 0.3s ease;
  pointer-events: none;
}

.premium-input {
  width: 100%;
  padding: 12px 16px 12px 42px !important;
  border-radius: 12px !important;
  border: 1px solid var(--border-glass) !important;
  background: var(--bg-glass-light) !important;
  backdrop-filter: blur(8px);
  font-size: 1rem;
  color: var(--text-primary);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.premium-input:focus {
  border-color: var(--accent-primary) !important;
  background: var(--bg-glass-heavy) !important;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1) !important;
}

.premium-input:focus + .premium-input-icon {
  color: var(--accent-primary);
  opacity: 1;
}

/* Premium Select Styles */
.premium-select-container {
  position: relative;
  width: 100%;
}

.premium-select-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background: rgba(248, 250, 252, 0.5);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--text-primary);
}

.premium-select-trigger:hover {
  background: white;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.trigger-content {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
}

.arrow-icon {
  transition: transform 0.3s ease;
}

.arrow-icon.rotate {
  transform: rotate(180deg);
}

.premium-select-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background: var(--bg-glass-heavy);
  backdrop-filter: blur(20px);
  border: 1px solid var(--border-glass);
  border-radius: 14px;
  box-shadow: var(--shadow-lg);
  z-index: 100;
  overflow: hidden;
  padding: 6px;
}

.premium-select-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  border: none;
  background: transparent;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.premium-select-option:hover {
  background: rgba(59, 130, 246, 0.1);
}

.premium-select-option.active {
  background: var(--accent-primary);
  color: white;
}

.option-text {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.option-label {
  font-weight: 700;
  font-size: 0.95rem;
}

.option-desc {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.form-actions-premium {
  margin-top: 32px;
  display: flex;
  justify-content: flex-end;
}

.btn-premium-submit {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 32px !important;
  border-radius: 14px !important;
  font-weight: 700 !important;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
}

.btn-premium-submit:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.3) !important;
}

/* ==========================================================
   ADMIN MOBILE ADAPTATION
   ========================================================== */
@media (max-width: 1024px) {
  .admin-dashboard-root .user-profile-dashboard,
  .admin-dashboard-root .user-profile-dashboard.no-stats {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
  }

  .admin-dashboard-root .profile-sidebar,
  .admin-dashboard-root .profile-stats-sidebar {
    position: static !important;
    top: auto !important;
    width: 100%;
    max-width: 100%;
    /* Без этого элемент как grid-item наследует min-width:auto и растягивает
       общую 1fr-колонку по содержимому (строке вкладок), несмотря на
       overflow-x:auto у .sidebar-nav — классический CSS Grid blowout. */
    min-width: 0;
  }

  .admin-dashboard-root .profile-sidebar {
    padding: 14px;
    border-radius: 14px;
    gap: 12px;
  }

  .admin-dashboard-root .sidebar-header {
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    gap: 10px;
    padding-bottom: 0;
  }

  .admin-dashboard-root .sidebar-avatar-placeholder {
    width: 46px !important;
    height: 46px !important;
    margin-bottom: 0 !important;
  }

  .admin-dashboard-root .sidebar-nav {
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    gap: 8px;
    padding-bottom: 4px;
  }

  .admin-dashboard-root .sidebar-nav::-webkit-scrollbar {
    display: none;
  }

  .admin-dashboard-root .nav-tab-side {
    width: auto;
    min-width: max-content;
    flex: 0 0 auto;
    padding: 9px 12px;
    border-radius: 10px;
  }

  .admin-dashboard-root .user-profile-dashboard .bento-grid-layout {
    grid-template-columns: 1fr !important;
    gap: 10px !important;
  }

  .admin-dashboard-root .bento-large,
  .admin-dashboard-root .bento-medium,
  .admin-dashboard-root .bento-small {
    grid-column: span 1 !important;
  }

  .admin-dashboard-root .admin-chart-slot {
    height: 280px !important;
  }
}

@media (max-width: 768px) {
  .admin-dashboard-root .profile-dashboard-main {
    gap: 12px !important;
  }

  .admin-dashboard-root .bento-card {
    border-radius: 14px;
  }

  .admin-dashboard-root .card-header {
    gap: 8px;
    flex-wrap: wrap;
  }

  .admin-dashboard-root .period-selector {
    width: 100%;
    justify-content: flex-start;
    overflow-x: auto;
    scrollbar-width: none;
  }

  .admin-dashboard-root .period-selector::-webkit-scrollbar {
    display: none;
  }

  .admin-dashboard-root .admin-notifications-top-grid,
  .admin-dashboard-root .admin-notifications-meta-row,
  .admin-dashboard-root .admin-notifications-technical-grid {
    grid-template-columns: 1fr !important;
  }

  .admin-dashboard-root .admin-notifications-header-actions {
    width: 100%;
    justify-items: stretch;
  }

  .admin-dashboard-root .admin-notifications-save-pill {
    width: 100%;
    justify-content: space-between;
  }

  .admin-dashboard-root .form-row-premium.horizontal {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 12px 14px;
  }

  .admin-dashboard-root .row-label-caps {
    width: 100%;
    font-size: 0.7rem;
    letter-spacing: 0.04em;
  }

  .admin-dashboard-root .row-value-right {
    justify-content: stretch;
  }

  .admin-dashboard-root .row-value-right > * {
    width: 100% !important;
    max-width: 100% !important;
  }
}

@media (max-width: 480px) {
  .admin-dashboard-root .profile-sidebar,
  .admin-dashboard-root .bento-card,
  .admin-dashboard-root .admin-modal {
    border-radius: 12px;
  }

  .admin-dashboard-root .profile-sidebar {
    padding: 12px;
  }

  .admin-dashboard-root .nav-tab-side {
    padding: 8px 10px;
    font-size: 0.82rem;
  }

  .admin-dashboard-root .admin-chart-slot {
    height: 240px !important;
  }

  .admin-dashboard-root .admin-modal {
    padding: 14px;
  }

  .admin-dashboard-root .admin-modal .admin-modal-actions {
    flex-direction: column;
  }

  .admin-dashboard-root .admin-modal .admin-modal-actions .admin-modal-btn-cancel,
  .admin-dashboard-root .admin-modal .admin-modal-actions .admin-modal-btn-submit {
    width: 100%;
  }
}

/* Promo codes tab */
.admin-promo-codes {
  width: 100%;
}

.admin-promo-layout {
  grid-template-columns: minmax(0, 1fr) !important;
}

.admin-promo-card {
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
}

.admin-promo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 24px 24px 16px;
}

.admin-promo-title {
  margin: 0;
}

.admin-promo-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.admin-promo-refresh-btn {
  min-width: 44px;
  padding: 10px 12px;
}

.admin-promo-banner {
  margin: 0 24px 12px;
}

.admin-promo-create-form {
  overflow: hidden;
  border-top: 1px solid var(--border-color, rgba(148, 163, 184, 0.2));
}

.admin-promo-select {
  width: 100%;
  max-width: 400px;
  cursor: pointer;
}

.admin-promo-list-wrap {
  padding: 8px 24px 24px;
}

.admin-promo-muted {
  color: var(--text-secondary);
  margin: 12px 0;
}

.admin-tx-link-cell {
  cursor: pointer;
  color: var(--accent-primary);
  font-weight: 600;
}

.admin-tx-link-cell:hover {
  text-decoration: underline;
}

/* ── Итоги по выборке транзакций ── */
.admin-tx-summary {
  padding: 20px 24px;
}

.admin-tx-summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.admin-tx-summary-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  background: var(--bg-secondary);
  min-width: 0;
}

.admin-tx-summary-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-secondary);
}

.admin-tx-summary-value {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
  word-break: break-word;
}

.admin-tx-summary-card--credit .admin-tx-summary-label {
  color: #16a34a;
}

.admin-tx-summary-card--debit .admin-tx-summary-label {
  color: #dc2626;
}

.admin-tx-summary-bytype {
  margin-top: 16px;
}

.admin-tx-summary-bytype-title {
  display: block;
  margin-bottom: 8px;
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-secondary);
}

.admin-tx-summary-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.admin-tx-summary-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  background: var(--bg-secondary);
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.admin-tx-summary-chip-value {
  font-weight: 700;
  color: var(--text-primary);
}

/* ── Чекбокс в мультивыборе ── */
.multi-select-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  border-radius: 4px;
  border: 1.5px solid var(--border-color, rgba(148, 163, 184, 0.5));
  color: #fff;
}

.multi-select-box.checked {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
}

.admin-promo-table-wrap {
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.2);
}

.admin-promo-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.admin-promo-table th,
.admin-promo-table td {
  padding: 12px 14px;
  text-align: left;
  border-bottom: 1px solid rgba(148, 163, 184, 0.15);
}

.admin-promo-table th {
  font-weight: 700;
  color: var(--text-secondary);
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: rgba(148, 163, 184, 0.06);
}

.admin-promo-table tbody tr {
  cursor: pointer;
  transition: background 0.15s ease;
}

.admin-promo-table tbody tr:hover {
  background: rgba(99, 102, 241, 0.06);
}

.admin-promo-table tbody tr.selected {
  background: rgba(99, 102, 241, 0.12);
}

.admin-promo-code {
  font-weight: 700;
  color: var(--text-primary);
  background: rgba(139, 92, 246, 0.1);
  padding: 2px 8px;
  border-radius: 6px;
}

.admin-promo-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
}

.admin-promo-badge.active {
  background: rgba(16, 185, 129, 0.15);
  color: #059669;
}

.admin-promo-badge.inactive {
  background: rgba(148, 163, 184, 0.15);
  color: var(--text-secondary);
}

.admin-promo-detail {
  margin: 0 24px 24px;
  padding: 20px;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  background: rgba(255, 255, 255, 0.4);
}

.admin-promo-detail-title {
  margin: 0 0 16px;
  font-size: 1rem;
  font-weight: 700;
}

.admin-promo-detail-grid {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.admin-promo-detail-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 20px;
}

.admin-promo-detail-row--edit {
  flex-direction: column;
  align-items: stretch;
}

.admin-promo-detail-label {
  min-width: 140px;
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-secondary);
}

.admin-promo-edit-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.admin-promo-edit-row .premium-input-minimal {
  flex: 1 1;
  min-width: 200px;
}

.admin-promo-save-btn {
  white-space: nowrap;
}

.admin-promo-toggle {
  border: none;
  border-radius: 10px;
  padding: 8px 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.admin-promo-toggle.on {
  background: rgba(239, 68, 68, 0.12);
  color: #dc2626;
}

.admin-promo-toggle.off {
  background: rgba(16, 185, 129, 0.12);
  color: #059669;
}

.admin-promo-toggle:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.admin-promo-stats-section,
.admin-promo-users-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(148, 163, 184, 0.2);
}

.admin-promo-section-title {
  margin: 0 0 14px;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
}

.admin-promo-stats-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

@media (max-width: 640px) {
  .admin-promo-stats-grid {
    grid-template-columns: 1fr;
  }
}

.admin-promo-stat-card {
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.admin-promo-stat-label {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-secondary);
}

.admin-promo-stat-value {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--text-primary);
}

.admin-promo-users-table tbody tr {
  cursor: default;
}

.admin-promo-users-table tbody tr:hover {
  background: rgba(148, 163, 184, 0.06);
}

.admin-promo-user-link {
  color: #6366f1;
  font-weight: 600;
  text-decoration: none;
}

.admin-promo-user-link:hover {
  text-decoration: underline;
}

.admin-promo-pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
}

.admin-promo-pagination-info {
  font-size: 0.88rem;
  color: var(--text-secondary);
}

/* Promo codes — list page */
.admin-promo-list-page {
  width: 100%;
}

.admin-promo-list-shell {
  max-width: 1100px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.06);
}

.admin-promo-list-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 24px 24px 16px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.15);
}

.admin-promo-list-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 1.25rem;
  font-weight: 800;
  color: var(--text-primary);
}

.admin-promo-list-title-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(139, 92, 246, 0.12);
  color: #8b5cf6;
}

.admin-promo-list-subtitle {
  margin: 6px 0 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.admin-promo-create-collapse {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border-bottom: 1px solid transparent;
}

.admin-promo-create-collapse.is-open {
  grid-template-rows: 1fr;
  border-bottom-color: rgba(148, 163, 184, 0.15);
}

.admin-promo-create-collapse-inner {
  min-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.15s ease;
  pointer-events: none;
}

.admin-promo-create-collapse.is-open .admin-promo-create-collapse-inner {
  opacity: 1;
  pointer-events: auto;
}

.admin-promo-create-panel {
  border-bottom: none;
}

.admin-promo-create-panel-inner {
  padding: 20px 24px 24px;
}

.admin-promo-create-panel-title {
  margin: 0 0 16px;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
}

.admin-promo-create-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

@media (max-width: 900px) {
  .admin-promo-create-grid {
    grid-template-columns: 1fr;
  }
}

.admin-promo-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.admin-promo-field-label {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-secondary);
}

.admin-promo-create-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.admin-promo-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 16px 24px;
  background: rgba(148, 163, 184, 0.05);
  border-bottom: 1px solid rgba(148, 163, 184, 0.12);
}

.admin-promo-search-wrap {
  position: relative;
  flex: 1 1;
  min-width: 220px;
  max-width: 420px;
}

.admin-promo-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary);
  pointer-events: none;
}

.admin-promo-search-input {
  width: 100%;
  padding: 11px 40px 11px 42px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: #fff;
  font-size: 0.92rem;
  color: var(--text-primary);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.admin-promo-search-input:focus {
  outline: none;
  border-color: rgba(99, 102, 241, 0.5);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.admin-promo-search-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
}

.admin-promo-search-clear:hover {
  background: rgba(148, 163, 184, 0.12);
  color: var(--text-primary);
}

.admin-promo-results-count {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
}

.admin-promo-list-body {
  padding: 8px 0 0;
}

.admin-promo-list-empty {
  padding: 32px 24px;
  text-align: center;
}

.admin-promo-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 24px;
  color: var(--text-secondary);
  text-align: center;
}

.admin-promo-empty-state p {
  margin: 0;
  font-size: 0.95rem;
}

.admin-promo-table-wrap--list {
  border: none;
  border-radius: 0;
}

.admin-promo-table--list tbody tr.admin-promo-table-row-link:focus-visible {
  outline: 2px solid rgba(99, 102, 241, 0.5);
  outline-offset: -2px;
}

.admin-promo-table-date {
  font-size: 0.86rem;
  color: var(--text-secondary);
  white-space: nowrap;
}

.admin-promo-table-col-action {
  width: 44px;
  text-align: right;
}

.admin-public-file-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.admin-promo-row-chevron {
  color: rgba(148, 163, 184, 0.7);
  transition: transform 0.15s ease, color 0.15s ease;
}

.admin-promo-table-row-link:hover .admin-promo-row-chevron {
  color: #6366f1;
  transform: translateX(2px);
}

.admin-promo-badge.large {
  padding: 6px 14px;
  font-size: 0.85rem;
}

.admin-promo-hero-status {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.admin-promo-hero-status-edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  flex-shrink: 0;
  border: 1px solid rgba(148, 163, 184, 0.28);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.85);
  color: var(--text-secondary);
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.admin-promo-hero-status-edit:hover:not(:disabled) {
  border-color: rgba(99, 102, 241, 0.4);
  color: #6366f1;
  background: #fff;
}

.admin-promo-hero-status-edit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Promo codes — detail page */
.admin-promo-detail-page {
  max-width: 1000px;
  margin: 0 auto;
}

.admin-promo-confirm-title {
  margin: 0;
  font-size: 1.1rem;
  color: var(--text-primary);
}

.admin-promo-confirm-subtitle {
  margin: 0 0 12px;
  color: var(--text-secondary);
}

.admin-promo-confirm-body .form-status.error {
  margin-top: 12px;
}

.admin-promo-page-card {
  padding: 22px 24px;
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.04);
}

.admin-promo-detail-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid rgba(139, 92, 246, 0.2);
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.08) 0%, rgba(99, 102, 241, 0.04) 100%);
}

.admin-promo-detail-hero-main {
  display: flex;
  align-items: center;
  gap: 16px;
}

.admin-promo-detail-hero-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: rgba(139, 92, 246, 0.15);
  color: #7c3aed;
}

.admin-promo-detail-hero-code {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 800;
}

.admin-promo-detail-hero-code code {
  background: transparent;
  padding: 0;
  font-size: inherit;
  color: var(--text-primary);
}

.admin-promo-detail-hero-meta {
  margin: 6px 0 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.admin-promo-detail-hero-dot {
  margin: 0 6px;
}

.admin-promo-detail-alert {
  margin-bottom: 16px;
}

.admin-promo-detail-layout {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 16px;
  margin-bottom: 16px;
}

@media (max-width: 860px) {
  .admin-promo-detail-layout {
    grid-template-columns: 1fr;
  }
}

.admin-promo-card-heading {
  margin: 0 0 18px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.admin-promo-users-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.admin-promo-users-header .admin-promo-card-heading {
  margin: 0;
}

.admin-promo-users-card {
  margin-top: 0;
}

@media (prefers-reduced-motion: reduce) {
  .admin-promo-create-collapse,
  .admin-promo-create-collapse-inner,
  .admin-promo-table tbody tr,
  .admin-promo-row-chevron,
  .admin-promo-search-input {
    transition: none !important;
  }
}

/* ============================================================
   News banners tab
   ============================================================ */
.admin-banner-title-icon {
  background: rgba(59, 130, 246, 0.12);
  color: #2563eb;
}

.admin-banner-create-inner {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.admin-banner-editor-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
  align-items: stretch;
}

@media (max-width: 900px) {
  .admin-banner-editor-grid {
    grid-template-columns: 1fr;
  }
}

.admin-banner-html-field {
  min-width: 0;
}

.admin-banner-html-input {
  min-height: 190px;
  resize: vertical;
  font-family: 'SFMono-Regular', ui-monospace, 'JetBrains Mono', Menlo, Consolas, monospace;
  font-size: 0.82rem;
  line-height: 1.5;
  tab-size: 2;
  white-space: pre;
  overflow-wrap: normal;
}

.admin-banner-preview-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.admin-banner-preview-box {
  position: relative;
  flex: 1 1;
  min-height: 380px;
  border: 1px dashed rgba(148, 163, 184, 0.4);
  border-radius: 12px;
  background:
    linear-gradient(45deg, rgba(148, 163, 184, 0.06) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.06) 75%) 0 0 / 16px 16px,
    linear-gradient(45deg, rgba(148, 163, 184, 0.06) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.06) 75%) 8px 8px / 16px 16px,
    #ffffff;
  padding: 14px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-banner-preview-box--modal {
  flex: none;
  height: 440px;
  min-height: 0;
  margin-bottom: 6px;
}

/* Инлайн phone-превью: рамка телефона 390×800 масштабируется JS-ом так, чтобы
   баннер целиком вписался в бокс (letterbox), как в детальном просмотре. */
.admin-banner-phone-stage {
  position: absolute;
  inset: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.admin-banner-phone-frame {
  flex: 0 0 auto;
  transform-origin: center center;
  border-radius: 26px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
}
.admin-banner-phone-iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  pointer-events: none;
}

.admin-banner-preview-content {
  width: 100%;
}

.admin-banner-preview-content img {
  max-width: 100%;
  height: auto;
}

.admin-banner-preview-empty {
  color: var(--text-secondary);
  font-size: 0.85rem;
  opacity: 0.75;
  text-align: center;
}

/* Isolated preview: the pasted document (its html/body/global <style>) renders
   inside a sandboxed iframe so it can never restyle the admin page. */
.admin-banner-preview-frame {
  width: 100%;
  height: 320px;
  border: 0;
  border-radius: 8px;
  background: #ffffff;
  display: block;
  pointer-events: none;
}
.admin-banner-preview-box--modal .admin-banner-preview-frame {
  height: 180px;
}
.admin-banner-card-preview .admin-banner-preview-frame {
  height: 100px;
  border-radius: 0;
}

/* Corner button that opens the zoomable detail view. */
.admin-banner-zoom-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(255, 255, 255, 0.92);
  color: #475569;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, transform 0.05s ease;
}
.admin-banner-zoom-btn:hover {
  background: #ffffff;
  color: #0f172a;
}
.admin-banner-zoom-btn:active {
  transform: scale(0.94);
}

/* Zoom modal ------------------------------------------------------------- */
/* Portaled to <body>; z-index sits above the fixed navbar (1000) and the other
   admin overlays so its toolbar is never clipped. */
.admin-banner-zoom-backdrop {
  z-index: 4000;
  padding: 24px;
}
.admin-banner-zoom {
  display: flex;
  flex-direction: column;
  width: min(760px, 100%);
  height: min(88vh, 920px);
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.35);
}
.admin-banner-zoom-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
}
.admin-banner-zoom-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.admin-banner-zoom-controls {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.admin-banner-zoom-ctrl,
.admin-banner-zoom-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.3);
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  transition: background 0.15s ease;
}
.admin-banner-zoom-ctrl:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.admin-banner-zoom-ctrl:hover:not(:disabled),
.admin-banner-zoom-close:hover {
  background: rgba(148, 163, 184, 0.12);
}
.admin-banner-zoom-close {
  margin-left: 6px;
}
.admin-banner-zoom-pct {
  min-width: 58px;
  height: 34px;
  padding: 0 8px;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.3);
  background: #ffffff;
  color: #0f172a;
  font-weight: 600;
  font-size: 0.82rem;
  cursor: pointer;
}
.admin-banner-zoom-stage {
  flex: 1 1;
  overflow: auto;
  display: flex;
  padding: 20px;
  background:
    linear-gradient(45deg, rgba(148, 163, 184, 0.09) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.09) 75%) 0 0 / 18px 18px,
    linear-gradient(45deg, rgba(148, 163, 184, 0.09) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.09) 75%) 9px 9px / 18px 18px,
    #f1f5f9;
}
.admin-banner-zoom-sizer {
  margin: auto;
  flex: 0 0 auto;
}
.admin-banner-zoom-frame-wrap {
  transform-origin: top left;
}
.admin-banner-zoom-frame {
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
}

.admin-banner-dates-grid {
  grid-template-columns: 1fr 1fr;
}

@media (max-width: 640px) {
  .admin-banner-dates-grid {
    grid-template-columns: 1fr;
  }
}

.admin-banner-registered-hint {
  grid-column: 1 / -1;
  margin-top: -2px;
}

.admin-banner-audience-field {
  gap: 10px;
}

.admin-banner-audience-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

@media (max-width: 640px) {
  .admin-banner-audience-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.admin-banner-audience-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 10px 12px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.7);
  color: var(--text-secondary);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.admin-banner-audience-pill:hover {
  border-color: rgba(59, 130, 246, 0.4);
  color: #2563eb;
}

.admin-banner-audience-pill.active {
  border-color: transparent;
  background: linear-gradient(135deg, #3b82f6 0%, #6366f1 100%);
  color: #fff;
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.25);
}

.admin-banner-ids-input {
  margin-top: 10px;
  min-height: 70px;
  resize: vertical;
  font-family: 'SFMono-Regular', ui-monospace, Menlo, Consolas, monospace;
  font-size: 0.8rem;
}

.admin-banner-hint {
  display: block;
  margin-top: 6px;
  font-size: 0.78rem;
  color: var(--text-secondary);
}

/* Cards list */
.admin-banner-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 16px;
  padding: 4px 2px;
}

@media (max-width: 640px) {
  .admin-banner-cards {
    grid-template-columns: 1fr;
  }
}

.admin-banner-card {
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.05);
  overflow: hidden;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.admin-banner-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.1);
  border-color: rgba(99, 102, 241, 0.28);
}

.admin-banner-card-preview {
  position: relative;
  max-height: 130px;
  overflow: hidden;
  padding: 14px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.15);
  background:
    linear-gradient(45deg, rgba(148, 163, 184, 0.05) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.05) 75%) 0 0 / 14px 14px,
    #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-banner-card-preview .admin-banner-preview-content img {
  max-width: 100%;
  height: auto;
}

.admin-banner-card-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  flex: 1 1;
}

.admin-banner-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.admin-banner-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 11px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.admin-banner-badge.all {
  background: rgba(100, 116, 139, 0.14);
  color: #475569;
}

.admin-banner-badge.customer {
  background: rgba(16, 185, 129, 0.14);
  color: #059669;
}

.admin-banner-badge.provider {
  background: rgba(245, 158, 11, 0.16);
  color: #d97706;
}

.admin-banner-badge.users {
  background: rgba(139, 92, 246, 0.14);
  color: #7c3aed;
}

.admin-banner-live-dot {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.74rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.admin-banner-live-dot .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #cbd5e1;
}

.admin-banner-live-dot.live {
  color: #059669;
}

.admin-banner-live-dot.live .dot {
  background: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.18);
}

.admin-banner-card-snippet {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.45;
  color: var(--text-primary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.admin-banner-card-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: auto;
}

.admin-banner-meta-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  color: var(--text-secondary);
}

.admin-banner-card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 16px;
  border-top: 1px solid rgba(148, 163, 184, 0.15);
  background: rgba(248, 250, 252, 0.6);
}

.admin-banner-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  border-radius: 9px;
  background: #fff;
  color: var(--text-secondary);
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.admin-banner-icon-btn:hover {
  border-color: rgba(59, 130, 246, 0.4);
  color: #2563eb;
}

.admin-banner-icon-btn.danger:hover {
  border-color: rgba(239, 68, 68, 0.45);
  color: #dc2626;
  background: rgba(239, 68, 68, 0.05);
}

/* Edit modal */
.admin-banner-edit-modal {
  max-width: 560px;
  width: 100%;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}

.admin-banner-edit-modal .modal-header,
.admin-banner-edit-modal .admin-modal-actions {
  flex-shrink: 0;
}

.admin-banner-edit-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  min-height: 0;
}

.admin-banner-edit-note {
  margin: 0;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

@media (prefers-reduced-motion: reduce) {
  .admin-banner-card,
  .admin-banner-audience-pill,
  .admin-banner-icon-btn {
    transition: none !important;
  }
}
/* ============================================================
   ТЁМНАЯ ТЕМА (роль DEV) — точечные переопределения admin.css.
   Здесь собраны места, где фон брался из токена (в тёмной теме
   становится тёмным), а цвет текста/иконки был захардкожен светлым
   значением — из-за чего в тёмной теме текст сливался или карточка
   оставалась белой. Значения подобраны так, чтобы контраст был
   комфортным (>= AA для текста).
   ============================================================ */

/* Плашки-статусы: синий текст был слишком тёмным на тёмном фоне */
:root[data-theme='dark'] .pill-blue {
  color: #93c5fd;
}

/* Форма уведомлений и общие поля формы */
:root[data-theme='dark'] .admin-notifications-form .form-field textarea,
:root[data-theme='dark'] .admin-notifications-result-title,
:root[data-theme='dark'] .admin-notifications-open-page-select {
  color: var(--text-primary);
}

:root[data-theme='dark'] .admin-notifications-result-text,
:root[data-theme='dark'] .admin-notifications-platform-item,
:root[data-theme='dark'] .form-field,
:root[data-theme='dark'] .modal-body,
:root[data-theme='dark'] .category-stat-percentage {
  color: var(--text-secondary);
}

:root[data-theme='dark'] .admin-notifications-save-pill-text {
  color: #bae6fd;
}

:root[data-theme='dark'] .admin-notifications-save-pill-hint {
  color: #7dd3fc;
}

:root[data-theme='dark'] .updates-title {
  color: var(--text-primary);
}

/* Иконки и значения на карточках-статистики — подсветлены */
:root[data-theme='dark'] .admin-card.accent-blue .card-icon {
  background: rgba(129, 140, 248, 0.18);
  color: #a5b4fc;
}

:root[data-theme='dark'] .admin-card.accent-purple .card-icon {
  background: rgba(167, 139, 250, 0.18);
  color: #c4b5fd;
}

:root[data-theme='dark'] .health-card.tone-blue .health-value {
  color: #60a5fa;
}

:root[data-theme='dark'] .health-card.tone-purple .health-value {
  color: #a78bfa;
}

:root[data-theme='dark'] .health-card.tone-green .health-value {
  color: #34d399;
}

:root[data-theme='dark'] .item-badge {
  color: #a5b4fc;
}

/* CategoryStats: пончик и легенда были белыми карточками */
:root[data-theme='dark'] .category-stats-donut-hole {
  background: linear-gradient(160deg, #273449 0%, #1e293b 100%);
  border-color: var(--border-color);
  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.04);
}

:root[data-theme='dark'] .category-stats-donut-total {
  color: var(--text-heading);
}

:root[data-theme='dark'] .category-stats-donut-ring--empty {
  background: conic-gradient(#334155 0% 100%);
}

:root[data-theme='dark'] .category-stats-legend-item {
  background: var(--bg-tertiary);
  border-color: var(--border-color);
}

:root[data-theme='dark'] .category-stats-legend-title {
  color: var(--text-primary);
}

:root[data-theme='dark'] .category-stats-legend-meta {
  color: #a5b4fc;
}

/* Промокоды / баннеры: инпуты и кнопки-чипы становились белыми */
:root[data-theme='dark'] .admin-promo-search-input,
:root[data-theme='dark'] .admin-banner-icon-btn {
  background: var(--bg-primary);
  color: var(--text-primary);
}

:root[data-theme='dark'] .admin-promo-hero-status-edit:hover:not(:disabled),
:root[data-theme='dark'] .premium-input-minimal:focus,
:root[data-theme='dark'] .premium-select-trigger:hover {
  background: var(--bg-tertiary);
}

:root[data-theme='dark'] .admin-banner-badge.all {
  color: var(--text-secondary);
}

/* Модалка увеличенного превью баннера: тёмная «обвязка»,
   при этом само полотно баннера (.admin-banner-zoom-frame) и
   мокап телефона остаются белыми — это реальный холст контента. */
:root[data-theme='dark'] .admin-banner-zoom {
  background: var(--bg-card);
}

:root[data-theme='dark'] .admin-banner-zoom-name,
:root[data-theme='dark'] .admin-banner-zoom-pct {
  color: var(--text-primary);
}

:root[data-theme='dark'] .admin-banner-zoom-ctrl,
:root[data-theme='dark'] .admin-banner-zoom-close,
:root[data-theme='dark'] .admin-banner-zoom-pct {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
}

:root[data-theme='dark'] .admin-banner-zoom-ctrl:hover:not(:disabled),
:root[data-theme='dark'] .admin-banner-zoom-close:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

:root[data-theme='dark'] .admin-banner-zoom-stage {
  background:
    linear-gradient(45deg, rgba(148, 163, 184, 0.06) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.06) 75%) 0 0 / 18px 18px,
    linear-gradient(45deg, rgba(148, 163, 184, 0.06) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.06) 75%) 9px 9px / 18px 18px,
    #0b1120;
}

/* ============================================================
   Тёмная тема: промокоды / баннеры / формы — оставались белыми.
   Настоящие «холсты» контента (превью баннера, рамка телефона,
   iframe-превью, zoom-frame) намеренно НЕ трогаем — они белые,
   потому что это реальная поверхность рендера баннера.
   ============================================================ */

/* Внешний «холст» обеих вкладок (промокоды и баннеры) */
:root[data-theme='dark'] .admin-promo-list-shell {
  background: var(--bg-secondary);
  border-color: var(--border-color);
}

/* Внутренние панели/карточки промокодов */
:root[data-theme='dark'] .admin-promo-detail,
:root[data-theme='dark'] .admin-promo-stat-card,
:root[data-theme='dark'] .admin-promo-page-card {
  background: var(--bg-tertiary);
  border-color: var(--border-color);
}

:root[data-theme='dark'] .admin-promo-hero-status-edit {
  background: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-secondary);
}

/* Поля ввода и триггер селекта (форма сотрудника + создание промокода) */
:root[data-theme='dark'] .premium-input-minimal,
:root[data-theme='dark'] .premium-select-trigger {
  background: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
}

/* Баннеры: карточки списка, «таблетки» аудитории, панель действий */
:root[data-theme='dark'] .admin-banner-card {
  background: var(--bg-secondary);
  border-color: var(--border-color);
}

:root[data-theme='dark'] .admin-banner-card-actions {
  background: var(--bg-tertiary);
  border-top-color: var(--border-color);
}

:root[data-theme='dark'] .admin-banner-audience-pill {
  background: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-secondary);
}

:root[data-theme='dark'] .admin-banner-audience-pill:hover {
  border-color: rgba(96, 165, 250, 0.45);
  color: #93c5fd;
}

:root[data-theme='dark'] .admin-banner-audience-pill.active {
  background: rgba(59, 130, 246, 0.22);
  border-color: rgba(96, 165, 250, 0.55);
  color: #dbeafe;
  box-shadow: 0 0 0 1px rgba(96, 165, 250, 0.25) inset;
}

/* ── Маркетплейс (DEV) ── */
.admin-mkt-title-icon {
  background: rgba(59, 130, 246, 0.12);
  color: #3b82f6;
}

/* Переключатель разделов: Сервисы / Покупки */
.admin-mkt-tabs {
  display: flex;
  gap: 8px;
  padding: 18px 24px 16px;
  margin-bottom: 0;
  border-bottom: 1px solid rgba(148, 163, 184, 0.12);
  flex-wrap: wrap;
}

.admin-mkt-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  background: transparent;
  color: var(--text-secondary);
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.admin-mkt-tab:hover {
  color: var(--text-primary);
  border-color: rgba(59, 130, 246, 0.4);
}

.admin-mkt-tab.active {
  background: rgba(59, 130, 246, 0.12);
  border-color: rgba(59, 130, 246, 0.5);
  color: #3b82f6;
}

.admin-mkt-tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: rgba(59, 130, 246, 0.18);
  color: #3b82f6;
  font-size: 0.72rem;
  font-weight: 700;
}

/* Иконка сервиса */
.admin-mkt-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  object-fit: cover;
  line-height: 1;
}

.admin-mkt-icon--empty,
.admin-mkt-icon--text {
  background: rgba(148, 163, 184, 0.14);
  color: var(--text-secondary);
}

.admin-mkt-col-icon {
  width: 56px;
}

.admin-public-file-thumb {
  display: inline-block;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
}

.admin-public-file-url {
  max-width: 420px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-mkt-col-actions {
  width: 96px;
  text-align: right;
}

.admin-mkt-row-actions {
  display: inline-flex;
  gap: 8px;
  justify-content: flex-end;
}

.admin-mkt-cell-title {
  font-weight: 600;
  color: var(--text-primary);
}

.admin-mkt-cell-desc {
  max-width: 320px;
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-mkt-cell-price {
  font-weight: 700;
  white-space: nowrap;
}

/* Карточки сервисов (в стиле карточек баннеров) */
.admin-mkt-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  padding: 20px 24px 24px;
}

@media (max-width: 640px) {
  .admin-mkt-cards {
    grid-template-columns: 1fr;
  }
}

.admin-mkt-card {
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.05);
  overflow: hidden;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.admin-mkt-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.1);
  border-color: rgba(59, 130, 246, 0.28);
}

.admin-mkt-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 16px 0;
}

.admin-mkt-card-head .admin-mkt-icon {
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}

.admin-mkt-card-price {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(16, 185, 129, 0.12);
  color: #059669;
  font-size: 0.9rem;
  font-weight: 800;
  white-space: nowrap;
}

.admin-mkt-card-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px 14px;
  flex: 1 1;
}

.admin-mkt-card-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.3;
}

.admin-mkt-card-desc {
  margin: 0;
  font-size: 0.86rem;
  line-height: 1.45;
  color: var(--text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.5em;
}

.admin-mkt-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: auto;
  padding-top: 4px;
}

.admin-mkt-meta-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  color: var(--text-secondary);
}

.admin-mkt-card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 16px;
  border-top: 1px solid rgba(148, 163, 184, 0.15);
  background: rgba(248, 250, 252, 0.6);
}

.admin-mkt-hint {
  display: block;
  margin-top: 4px;
  font-size: 0.72rem;
  color: var(--text-secondary);
}

.admin-mkt-desc-field {
  margin-top: 4px;
}

/* В форме сервиса общих полей два — иконка и цена */
.admin-mkt-form-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

@media (max-width: 900px) {
  .admin-mkt-form-grid {
    grid-template-columns: 1fr;
  }
}

/* Мультиязычный блок формы сервиса: вкладки RO / RU / EN */
.admin-mkt-lang-block {
  margin-top: 12px;
  padding: 12px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 12px;
  background: rgba(248, 250, 252, 0.5);
}

.admin-mkt-lang-tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.admin-mkt-lang-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  background: transparent;
  color: var(--text-secondary);
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.admin-mkt-lang-tab:hover:not(:disabled) {
  color: var(--text-primary);
  border-color: rgba(59, 130, 246, 0.4);
}

.admin-mkt-lang-tab.active {
  background: rgba(59, 130, 246, 0.12);
  border-color: rgba(59, 130, 246, 0.5);
  color: #3b82f6;
}

.admin-mkt-lang-tab:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Точка-индикатор: заполнено ли название на этом языке */
.admin-mkt-lang-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(148, 163, 184, 0.55);
}

.admin-mkt-lang-dot.filled {
  background: #22c55e;
}

.admin-mkt-lang-field {
  margin-top: 10px;
}

:root[data-theme='dark'] .admin-mkt-lang-block {
  background: var(--bg-tertiary);
  border-color: var(--border-color);
}

:root[data-theme='dark'] .admin-mkt-lang-tab {
  border-color: var(--border-color);
}

.admin-mkt-desc-input {
  resize: vertical;
  min-height: 70px;
  font-family: inherit;
}

/* Статусы покупок */
.admin-mkt-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.admin-mkt-status--open {
  background: rgba(245, 158, 11, 0.15);
  color: #d97706;
}

.admin-mkt-status--in-progress {
  background: rgba(59, 130, 246, 0.15);
  color: #2563eb;
}

.admin-mkt-status--closed {
  background: rgba(16, 185, 129, 0.15);
  color: #059669;
}

/* Статистика покупок */
.admin-mkt-stats-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 20px 24px 4px;
}

/* Тулбар покупок (счётчик + сортировка) */
.admin-mkt-purchases-toolbar {
  background: transparent;
  border-bottom: none;
  padding: 12px 24px 16px;
}

/* Тулбар покупок теперь первый блок в разделе (счётчик покупок убрали) —
   возвращаем стандартный вид тулбара, как у сервисов. */
.admin-mkt-purchases-toolbar--first {
  background: rgba(148, 163, 184, 0.05);
  border-bottom: 1px solid rgba(148, 163, 184, 0.12);
  padding: 16px 24px;
}

/* Выпадашка сортировки покупок (2 колонки: поле сортировки + направление).
   Раньше была 360px — слишком узко, подписи вроде «По дате» переносились
   на две строки. */
.admin-mkt-sort-dropdown {
  width: 460px;
  min-width: 460px;
  max-width: calc(100vw - 16px);
}

@media (max-width: 640px) {
  .admin-mkt-sort-dropdown {
    width: calc(100vw - 16px);
    min-width: 0;
  }
}

/* Отступы стандартного пейджера (orders-pager) внутри маркетплейса —
   такой же, как в поиске пользователей/заказов, но с горизонтальным полем
   вровень с остальными блоками карточки-шелла. */
.admin-marketplace .orders-pager {
  padding: 12px 24px 20px;
  margin: 0;
}

.admin-mkt-stat-card {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  min-width: 240px;
  padding: 18px 24px;
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.05);
}

.admin-mkt-stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  color: #fff;
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.32);
}

.admin-mkt-stat-body {
  display: flex;
  flex-direction: column;
}

.admin-mkt-stat-value {
  font-size: 1.5rem;
  font-weight: 800;
  line-height: 1.1;
  color: var(--text-primary);
}

.admin-mkt-stat-label {
  font-size: 0.82rem;
  color: var(--text-secondary);
}

.admin-mkt-edit-modal .admin-mkt-form-grid,
.admin-mkt-edit-body .admin-promo-create-grid {
  grid-template-columns: minmax(0, 1fr);
}

:root[data-theme='dark'] .admin-mkt-tab {
  border-color: var(--border-color);
}

:root[data-theme='dark'] .admin-mkt-stat-card {
  background: var(--bg-tertiary);
  border-color: var(--border-color);
}

:root[data-theme='dark'] .admin-mkt-icon--empty,
:root[data-theme='dark'] .admin-mkt-icon--text {
  background: var(--bg-secondary);
}

:root[data-theme='dark'] .admin-mkt-card {
  background: var(--bg-tertiary);
  border-color: var(--border-color);
}

:root[data-theme='dark'] .admin-mkt-card:hover {
  border-color: rgba(96, 165, 250, 0.4);
}

:root[data-theme='dark'] .admin-mkt-card-actions {
  background: rgba(255, 255, 255, 0.02);
  border-top-color: var(--border-color);
}

:root[data-theme='dark'] .admin-mkt-card-price {
  background: rgba(16, 185, 129, 0.18);
  color: #34d399;
}

/* ── Админка без внутренней колонки вкладок (разделы в общем сайдбаре) ── */
.admin-dashboard-root .user-profile-dashboard.no-side {
  grid-template-columns: 1fr 240px !important;
}

.admin-dashboard-root .user-profile-dashboard.no-side.no-stats {
  grid-template-columns: 1fr !important;
}

@media (max-width: 1100px) {
  .admin-dashboard-root .user-profile-dashboard.no-side {
    grid-template-columns: 1fr !important;
  }
}

.admin-page-head {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 4px;
}

.admin-page-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  border-radius: 13px;
  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));
  color: var(--accent-primary, #2563eb);
}

.admin-page-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--text-heading, var(--text-primary));
}

.admin-page-sub {
  margin: 2px 0 0;
  color: var(--text-secondary);
  font-size: 0.82rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
`, "",{"version":3,"sources":["webpack://./src/css/admin.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,8DAA8D;AAC9D;EACE,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE;IACE,iDAAiD;IACjD,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;AAC3B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;AACtB;;AAEA,0HAA0H;AAC1H;EACE,gCAAgC;EAChC,wCAAwC;EACxC,6BAA6B;EAC7B,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mJAAmJ;AACrJ;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iDAAiD;EACjD,kFAAkF;EAClF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,kFAAkF;EAClF,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gDAAgD;EAChD,aAAa;EACb,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;;AAGA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,4BAA4B;AAC9B;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,+EAA+E;EAC/E,4DAA4D;AAC9D;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,sDAAsD;AACtD;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,wBAAwB;EACxB,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,qCAAqC;EACrC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,wFAAwF;AAC1F;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA,wCAAwC;;AAExC;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,uDAAuD;EACzD;AACF;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,wDAAwD;EACxD,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iEAAiE;EACjE,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,qCAAqC;EACrC,4BAA4B;EAC5B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA,wCAAwC;;AAExC;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,8EAA8E;EAC9E,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8EAA8E;EAC9E,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,wDAAwD;AAC1D;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;IACrC,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA,kGAAkG;AAClG;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,8CAA8C;EAC9C,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,6DAA6D;EAC7D,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,oDAAoD;EACpD,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,oBAAoB;EACpB,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;8CAE4C;;EAE5C,mBAAmB;EACnB;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,gDAAgD;IAChD,6CAA6C;IAC7C,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,gDAAgD;IAChD,8CAA8C;IAC9C,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA,oBAAoB;EACpB;IACE,wCAAwC;IACxC,8CAA8C;IAC9C,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,8CAA8C;IAC9C,sCAAsC;IACtC,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;;IAEE,4CAA4C;IAC5C,6CAA6C;EAC/C;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,2BAA2B;EAC7B;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,8CAA8C;IAC9C,yCAAyC;IACzC,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA,4BAA4B;EAC5B;IACE,mDAAmD;IACnD,6BAA6B;IAC7B,yDAAyD;IACzD,6BAA6B;IAC7B,0DAA0D;EAC5D;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;MACE,sBAAsB;MACtB,oBAAoB;IACtB;;IAEA;MACE,0BAA0B;IAC5B;EACF;AACF;;AAEA,gCAAgC;AAChC;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,mDAAmD;AACrD;;AAEA,+DAA+D;AAC/D;EACE,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,0CAA0C;EAC1C,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iDAAiD;EACjD,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sFAAsF;AACxF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA,uIAAuI;AACvI;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,uCAAuC;EACvC,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,8BAA8B;EAC9B,gDAAgD;EAChD,4CAA4C;EAC5C,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA;EACE,8CAA8C;EAC9C,4CAA4C;EAC5C,wDAAwD;AAC1D;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,eAAe;EACf,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iCAAiC;EACjC,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,iEAAiE;AACnE;;AAEA;EACE,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA;;+DAE+D;AAC/D;EACE;;IAEE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;;IAEE,2BAA2B;IAC3B,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf;;wEAEoE;IACpE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,qBAAqB;IACrB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;;;IAGE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,oBAAoB;AACpB;EACE,WAAW;AACb;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,+BAA+B;EAC/B,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iEAAiE;EACjE,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gEAAgE;EAChE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,4BAA4B;EAC5B,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,+FAA+F;AACjG;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;;;;IAKE,2BAA2B;EAC7B;AACF;;AAEA;;iEAEiE;AACjE;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yFAAyF;EACzF,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB;;;WAGS;EACT,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;2EAC2E;AAC3E;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;sEACsE;AACtE;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,yEAAyE;AAC3E;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;;AAEA,6EAA6E;AAC7E;oDACoD;AACpD;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iDAAiD;AACnD;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,aAAa;EACb;;;WAGS;AACX;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mGAAmG;AACrG;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uEAAuE;EACvE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;EAC7C,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kDAAkD;EAClD;;QAEM;EACN,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;;;IAGE,2BAA2B;EAC7B;AACF;AACA;;;;;;;iEAOiE;;AAEjE,kEAAkE;AAClE;EACE,cAAc;AAChB;;AAEA,yCAAyC;AACzC;;;EAGE,0BAA0B;AAC5B;;AAEA;;;;;EAKE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,4DAA4D;AAC5D;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,6DAA6D;EAC7D,iCAAiC;EACjC,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,iEAAiE;AACjE;;EAEE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;kEAEkE;AAClE;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;;EAGE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;;EAEE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE;;;WAGS;AACX;;AAEA;;;;;iEAKiE;;AAEjE,wDAAwD;AACxD;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA,0CAA0C;AAC1C;;;EAGE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA,yEAAyE;AACzE;;EAEE,8BAA8B;EAC9B,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,oEAAoE;AACpE;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;EACd,oDAAoD;AACtD;;AAEA,4BAA4B;AAC5B;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;EAC7C,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;wDACwD;AACxD;EACE,qCAAqC;EACrC,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;;mBAEmB;AACnB;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE;IACE,yBAAyB;IACzB,YAAY;EACd;AACF;;AAEA;;iDAEiD;AACjD;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,yDAAyD;EACzD,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB","sourcesContent":["/* Admin dashboard styling aligned with the site's gradient/glass look */\n.admin-page {\n  background: transparent;\n  padding: 0;\n  border-radius: 0;\n  box-shadow: none;\n  animation: none;\n  color: var(--text-primary);\n}\n\n.admin-hero {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  align-items: stretch;\n  margin-bottom: 0px;\n}\n\n.admin-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin-bottom: 0px;\n}\n\n@media (max-width: 900px) {\n  .admin-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 640px) {\n  .admin-stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Admin layout: 3 columns (Sidebar, Content, Stats Sidebar) */\n.admin-dashboard-root .user-profile-dashboard {\n  grid-template-columns: 280px 1fr 240px !important;\n  gap: 20px !important;\n}\n\n@media (max-width: 1400px) {\n  .admin-dashboard-root .user-profile-dashboard {\n    grid-template-columns: 260px 1fr 220px !important;\n    gap: 12px !important;\n  }\n}\n\n@media (max-width: 1100px) {\n  .admin-dashboard-root .user-profile-dashboard {\n    grid-template-columns: 240px 1fr !important;\n  }\n}\n\n/* Overriding global bento gaps for Admin */\n.admin-dashboard-root.user-details-page {\n  padding-top: 0 !important;\n}\n\n.admin-dashboard-root .user-profile-dashboard {\n  grid-template-columns: 280px 1fr 240px !important;\n}\n\n.admin-dashboard-root .user-profile-dashboard .bento-grid-layout {\n  grid-template-columns: repeat(2, 1fr) !important;\n  gap: 12px !important;\n}\n\n.admin-dashboard-root .user-profile-dashboard.no-stats {\n  grid-template-columns: 280px 1fr !important;\n}\n\n.admin-dashboard-root .user-profile-dashboard .profile-dashboard-main {\n  gap: 12px !important;\n}\n\n/* Recharts + backdrop-filter + transform на bento дают «белую плашку» после быстрого скролла (слой не перерисовывается) */\n.admin-dashboard-root .profile-dashboard-main .bento-card {\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n[data-theme='dark'] .admin-dashboard-root .profile-dashboard-main .bento-card {\n  background: var(--bg-secondary);\n}\n\n.admin-dashboard-root .profile-dashboard-main .bento-card:hover {\n  transform: none;\n  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.08);\n}\n\n[data-theme='dark'] .admin-dashboard-root .profile-dashboard-main .bento-card:hover {\n  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);\n}\n\n.admin-dashboard-root .profile-dashboard-main .admin-chart-slot {\n  position: relative;\n  isolation: isolate;\n}\n\n.admin-hero-text {\n  padding: 24px;\n  border-radius: 18px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n.admin-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--nav-active-color);\n  background: var(--nav-active-bg);\n  border-radius: 999px;\n  letter-spacing: 0.01em;\n}\n\n.admin-title {\n  margin: 16px 0 10px;\n  font-size: 2.4rem;\n  font-weight: 700;\n  line-height: 1.2;\n  color: var(--text-primary);\n  letter-spacing: -0.015em;\n}\n\n.admin-subtitle {\n  color: var(--text-secondary);\n  font-size: 1.05rem;\n  margin-bottom: 18px;\n}\n\n.admin-cta {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 14px;\n}\n\n.admin-btn {\n  border: none;\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.admin-btn.primary {\n  color: #fff;\n  background: var(--accent-color);\n  box-shadow: var(--shadow-sm);\n}\n\n.admin-btn.primary:hover {\n  background: var(--accent-hover);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.admin-btn.ghost {\n  color: var(--text-primary);\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n}\n\n.admin-btn.ghost:hover {\n  background: var(--nav-hover-bg);\n  transform: translateY(-2px);\n}\n\n.admin-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #64748b;\n  font-size: 0.95rem;\n}\n\n/* Premium Card Design */\n.admin-card-premium {\n  background: var(--bg-glass-heavy);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid var(--border-glass);\n  border-radius: 16px;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px -1px rgba(0, 0, 0, 0.01);\n  overflow: hidden;\n  position: relative;\n}\n\n.admin-card-premium:hover {\n  /* Hover zoom disabled as requested */\n  transform: none;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px -1px rgba(0, 0, 0, 0.01);\n  border-color: var(--border-glass);\n}\n\n.admin-card-premium .card-header {\n  padding: 0 !important;\n  margin: 0 !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: none !important;\n}\n\n.admin-card-premium .card-divider {\n  height: 1px;\n  width: 100%;\n  border-top: 1px dashed rgba(255, 255, 255, 0.15);\n  margin: 1px 0;\n  opacity: 0.5;\n}\n\n[data-theme='light'] .admin-card-premium .card-divider {\n  border-top: 1px dashed rgba(0, 0, 0, 0.08);\n}\n\n\n.admin-card-premium .card-title {\n  color: var(--text-secondary);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n/* Period Selector Styles */\n.period-selector {\n  display: flex;\n  background: rgba(0, 0, 0, 0.04);\n  padding: 2px;\n  border-radius: 8px;\n  gap: 1px;\n  flex-shrink: 0;\n}\n\n.period-selector.vertical {\n  flex-direction: column;\n  padding: 1px;\n  gap: 2px;\n}\n\n.period-selector.vertical .period-pill {\n  padding: 4px 2px;\n  min-width: 18px;\n}\n\n[data-theme='dark'] .period-selector {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.period-pill {\n  border: none;\n  background: transparent;\n  padding: 3px 6px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 20px;\n  text-align: center;\n}\n\n.period-pill:hover {\n  color: var(--text-primary);\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.period-pill.active {\n  background: white;\n  color: var(--accent-color);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n[data-theme='dark'] .period-pill.active {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n\n.admin-card-premium .card-body {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  /* Vertical centering */\n  justify-content: flex-start;\n  gap: 16px;\n  width: 100%;\n}\n\n.admin-card-metrics-left {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  flex: 1;\n}\n\n.admin-card-premium .card-value {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  letter-spacing: -0.04em;\n  margin: 0;\n  line-height: 1.1;\n  text-align: center;\n  width: auto;\n}\n\n.admin-card-premium .card-trend {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  background: rgba(16, 185, 129, 0.12);\n  color: #10b981;\n  align-self: center;\n  /* Ensure it centers in flex column */\n}\n\n.admin-card-premium .card-trend.negative {\n  background: rgba(239, 68, 68, 0.12);\n  color: #ef4444;\n}\n\n/* Fix icon spacing in trend badges */\n.admin-card-premium .card-trend svg {\n  margin-right: 6px !important;\n}\n\n\n.admin-card-premium .icon-circle-premium {\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: white;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04), inset 0 0 0 1px rgba(0, 0, 0, 0.02);\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n.admin-card-premium:hover .icon-circle-premium {\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04), inset 0 0 0 1px rgba(0, 0, 0, 0.02);\n}\n\n.admin-dot {\n  width: 6px;\n  height: 6px;\n  background: #c084fc;\n  border-radius: 50%;\n  display: inline-flex;\n}\n\n/* Push notifications: centered hero (no aside card) */\n.admin-notifications-hero--centered {\n  grid-template-columns: 1fr;\n  justify-items: stretch;\n}\n\n/* «Назад» внутри той же карточки hero, без сдвига центрального блока */\n.admin-notifications-hero-text.admin-hero-text {\n  position: relative;\n  text-align: center;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.admin-notifications-hero-back {\n  position: absolute;\n  z-index: 2;\n  top: 20px;\n  inset-inline-start: 20px;\n  margin: 0;\n  max-width: min(13rem, 42%);\n  white-space: normal;\n  text-align: start;\n  line-height: 1.25;\n  hyphens: auto;\n}\n\n.profile-stats-sidebar {\n  padding-top: 0;\n}\n\n.admin-stats-strip {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 10px;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.admin-status-badge {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 16px;\n  background: var(--bg-glass-heavy);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid var(--border-glass);\n  border-radius: 12px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);\n  transition: all 0.3s ease;\n}\n\n.admin-status-badge:hover {\n  transform: translateY(-2px);\n  border-color: var(--accent-primary);\n  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);\n}\n\n.admin-status-badge .stat-label {\n  display: flex;\n  align-items: center;\n  color: var(--text-secondary);\n}\n\n.admin-status-badge .stat-value {\n  color: var(--text-primary);\n  font-weight: 700;\n  margin-left: 4px;\n}\n\n@media (max-width: 520px) {\n  .admin-notifications-hero-back {\n    position: static;\n    align-self: flex-start;\n    margin: 0 0 10px;\n    max-width: 100%;\n    white-space: normal;\n    text-align: start;\n  }\n}\n\n.admin-notifications-hero--centered .admin-subtitle {\n  max-width: 36rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.admin-notifications-hero--centered .admin-cta {\n  justify-content: center;\n}\n\n.admin-notifications-hero--centered .admin-meta {\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.admin-hero-card {\n  border-radius: 18px;\n  padding: 20px;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n  position: relative;\n  overflow: hidden;\n}\n\n.admin-hero-card::after {\n  content: '';\n}\n\n.hero-card-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  gap: 16px;\n  position: relative;\n  z-index: 1;\n}\n\n.hero-metric {\n  display: grid;\n  gap: 6px;\n}\n\n.metric-label {\n  color: #cbd5e1;\n  font-size: 0.95rem;\n}\n\n.metric-value {\n  font-size: 2.1rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #fff;\n}\n\n.metric-value.small {\n  font-size: 1.6rem;\n}\n\n.metric-trend {\n  font-size: 0.9rem;\n  font-weight: 700;\n  padding: 6px 10px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  width: fit-content;\n}\n\n.metric-trend.up {\n  background: rgba(16, 185, 129, 0.16);\n  color: #34d399;\n}\n\n.metric-trend.neutral {\n  background: rgba(148, 163, 184, 0.2);\n  color: #cbd5e1;\n}\n\n.hero-divider {\n  width: 1px;\n  height: 100%;\n  background: linear-gradient(180deg, transparent, rgba(226, 232, 240, 0.65), transparent);\n}\n\n.hero-quick {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n}\n\n.mini-metric {\n  background: var(--bg-primary);\n  border-radius: 14px;\n  padding: 12px 14px;\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Removed duplicate .admin-stats-grid */\n\n.admin-form-card {\n  margin-bottom: 18px;\n  padding: 18px;\n  border-radius: 16px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n.admin-form-card .panel-title {\n  margin: 4px 0 0;\n}\n\n.form-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.admin-form {\n  display: grid;\n  gap: 12px;\n}\n\n/* Push notifications: compact layout, sections, responsive columns */\n.admin-notifications-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.admin-notifications-card.admin-form-card {\n  padding: 14px 16px 16px;\n}\n\n.admin-notifications-inner {\n  max-width: min(880px, 100%);\n  margin-inline: auto;\n}\n\n.admin-notifications-form {\n  gap: 10px;\n}\n\n.admin-notifications-form-header.form-header {\n  align-items: flex-start;\n  margin-bottom: 10px;\n  gap: 10px 18px;\n  flex-wrap: wrap;\n}\n\n.admin-notifications-section {\n  display: grid;\n  gap: 10px;\n}\n\n.admin-notifications-section--technical {\n  padding-top: 12px;\n  margin-top: 4px;\n  border-top: 1px dashed rgba(148, 163, 184, 0.5);\n}\n\n.admin-notifications-section-kicker {\n  margin: 0 0 2px;\n  font-size: 0.95rem;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.admin-notifications-top-grid {\n  display: grid;\n  grid-template-columns: 1fr minmax(0, 220px);\n  gap: 10px 14px;\n  align-items: end;\n}\n\n.admin-notifications-meta-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px 14px;\n  align-items: end;\n}\n\n@media (min-width: 720px) {\n  .admin-notifications-meta-row {\n    grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);\n  }\n}\n\n.admin-notifications-technical-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px 14px;\n  align-items: end;\n}\n\n@media (min-width: 720px) {\n  .admin-notifications-technical-grid {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n}\n\n.admin-notifications-technical-field {\n  margin: 0;\n}\n\n.admin-notifications-form .form-field textarea {\n  padding: 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(226, 232, 240, 0.9);\n  background: var(--bg-primary);\n  font-size: 1rem;\n  font-family: inherit;\n  line-height: 1.45;\n  color: #0f172a;\n  outline: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.admin-notifications-form .form-field textarea:focus {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.18);\n}\n\n.admin-notifications-textarea--description {\n  resize: vertical;\n  min-height: 4.75rem;\n}\n\n.admin-notifications-textarea--ids {\n  resize: vertical;\n  min-height: 5.5rem;\n  font-family: ui-monospace, 'Cascadia Code', 'Consolas', monospace;\n  font-size: 1rem;\n}\n\n@media (max-width: 560px) {\n  .admin-notifications-top-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Notifications: header actions (save toggle) */\n.admin-notifications-header-actions {\n  display: grid;\n  justify-items: end;\n  gap: 6px;\n  min-width: 260px;\n}\n\n.admin-notifications-save-pill {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 999px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n  cursor: pointer;\n  user-select: none;\n}\n\n.admin-notifications-save-pill-input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n/* Removed duplicate .card-icon-circle */\n\n.admin-notifications-save-pill-ui {\n  width: 38px;\n  height: 22px;\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.35);\n  border: 1px solid rgba(148, 163, 184, 0.55);\n  position: relative;\n  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n  flex-shrink: 0;\n}\n\n.admin-notifications-save-pill-ui::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 2px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: var(--bg-primary);\n  transform: translateY(-50%);\n  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.14);\n  transition: left 0.22s ease;\n}\n\n.admin-notifications-save-pill-input:checked+.admin-notifications-save-pill-ui {\n  background: linear-gradient(135deg, #0ea5e9 0%, #6366f1 100%);\n  border-color: rgba(99, 102, 241, 0.65);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.16);\n}\n\n.admin-notifications-save-pill-input:checked+.admin-notifications-save-pill-ui::after {\n  left: 18px;\n}\n\n.admin-notifications-save-pill-text {\n  font-weight: 700;\n  color: #0c4a6e;\n  font-size: 0.9rem;\n  line-height: 1.1;\n}\n\n.admin-notifications-save-pill-hint {\n  font-size: 0.78rem;\n  color: #0369a1;\n  font-weight: 600;\n  text-align: right;\n  max-width: 420px;\n}\n\n@media (max-width: 768px) {\n  .admin-notifications-header-actions {\n    justify-items: start;\n    min-width: 0;\n  }\n\n  .admin-notifications-save-pill-hint {\n    text-align: left;\n  }\n}\n\n/* Notifications: result card */\n.admin-notifications-result {\n  margin-top: 16px;\n  padding: 16px;\n  background: rgba(99, 102, 241, 0.08);\n  border-radius: 12px;\n  border: 1px solid rgba(99, 102, 241, 0.2);\n}\n\n.admin-notifications-result-title {\n  margin: 0 0 8px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.admin-notifications-result-text {\n  margin: 0;\n  color: #475569;\n  font-weight: 600;\n}\n\n/* Push notifications: role + open page selects */\n.admin-notifications-role-select,\n.admin-notifications-open-page-select {\n  width: 100%;\n  max-width: 100%;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid rgba(99, 102, 241, 0.22);\n  background: var(--bg-secondary);\n  font-size: 0.98rem;\n  font-weight: 600;\n  color: #0f172a;\n  cursor: pointer;\n  outline: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  appearance: auto;\n}\n\n.admin-notifications-open-page-select {\n  min-height: 48px;\n}\n\n.admin-notifications-role-select:hover,\n.admin-notifications-open-page-select:hover {\n  border-color: rgba(99, 102, 241, 0.45);\n  background: var(--bg-primary);\n}\n\n.admin-notifications-role-select:focus,\n.admin-notifications-open-page-select:focus {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\n}\n\n.admin-notifications-platform-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.admin-notifications-platform-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border-radius: 10px;\n  border: 1px solid rgba(226, 232, 240, 0.95);\n  background: var(--bg-primary);\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: #334155;\n  cursor: pointer;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.admin-notifications-platform-item:focus-within {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.15);\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n}\n\n.form-field {\n  display: grid;\n  gap: 6px;\n  font-size: 0.95rem;\n  color: #475569;\n}\n\n.form-field input,\n.form-field select {\n  padding: 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(226, 232, 240, 0.9);\n  background: var(--bg-primary);\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.form-field input:focus,\n.form-field select:focus {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.18);\n}\n\n.form-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.form-status {\n  padding: 12px;\n  border-radius: 10px;\n  font-weight: 700;\n  font-size: 0.95rem;\n}\n\n.form-status.success {\n  background: rgba(16, 185, 129, 0.12);\n  color: #0f9f6e;\n  border: 1px solid rgba(16, 185, 129, 0.3);\n}\n\n.form-status.error {\n  background: rgba(239, 68, 68, 0.12);\n  color: #b91c1c;\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.admin-form-optional {\n  font-weight: 500;\n  font-size: 0.75rem;\n  color: var(--text-secondary, #64748b);\n  text-transform: none;\n  letter-spacing: normal;\n}\n\n.admin-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  z-index: 2000;\n}\n\n.admin-modal {\n  width: min(480px, 100%);\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 18px;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.25);\n  border: 1px solid rgba(226, 232, 240, 0.9);\n}\n\n.admin-notifications-confirm-backdrop {\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.admin-notifications-confirm-modal {\n  width: min(760px, calc(100vw - 32px));\n  max-height: calc(100vh - 32px);\n  display: flex;\n  flex-direction: column;\n  padding: 22px;\n}\n\n.admin-notifications-confirm-modal .modal-header {\n  margin-bottom: 14px;\n}\n\n.admin-notifications-confirm-modal .modal-body {\n  margin-bottom: 16px;\n  overflow-y: auto;\n  max-height: calc(100vh - 220px);\n  padding-right: 4px;\n}\n\n.admin-notifications-confirm-modal .confirm-list {\n  gap: 8px;\n}\n\n.admin-notifications-confirm-modal .confirm-list li {\n  padding: 12px 14px;\n}\n\n.admin-notifications-confirm-modal .modal-actions {\n  margin-top: auto;\n}\n\n@media (max-width: 768px) {\n  .admin-notifications-confirm-modal {\n    width: min(680px, calc(100vw - 24px));\n    max-height: calc(100vh - 24px);\n    padding: 18px;\n  }\n\n  .admin-notifications-confirm-modal .modal-body {\n    max-height: calc(100vh - 200px);\n  }\n}\n\n@media (max-width: 480px) {\n  .admin-notifications-confirm-backdrop {\n    padding: 10px;\n  }\n\n  .admin-notifications-confirm-modal {\n    width: 100%;\n    max-height: calc(100vh - 20px);\n    padding: 14px;\n    border-radius: 12px;\n  }\n\n  .admin-notifications-confirm-modal .modal-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.modal-body {\n  margin-bottom: 14px;\n  color: #475569;\n}\n\n.confirm-list {\n  list-style: none;\n  padding: 0;\n  margin: 8px 0 0;\n  display: grid;\n  gap: 6px;\n}\n\n.confirm-list li {\n  background: var(--bg-primary);\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n/* Кнопки подтверждения в модалке админки (нужен базовый .btn из user-details.css + донастройка) */\n.admin-modal .admin-modal-actions {\n  gap: 12px;\n  margin-top: 8px;\n  padding-top: 4px;\n}\n\n.admin-modal .admin-modal-actions .admin-modal-btn-cancel,\n.admin-modal .admin-modal-actions .admin-modal-btn-submit {\n  min-height: 44px;\n  padding: 12px 22px;\n  border-radius: 12px;\n  font-size: 0.9375rem;\n  font-weight: 700;\n}\n\n.admin-modal .admin-modal-actions .admin-modal-btn-cancel {\n  background: var(--bg-secondary, #f1f5f9);\n  color: var(--text-primary, #0f172a);\n  border: 1px solid var(--border-color, #e2e8f0);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.admin-modal .admin-modal-actions .admin-modal-btn-cancel:hover:not(:disabled) {\n  background: var(--bg-primary, #fff);\n  border-color: var(--accent-primary, #3b82f6);\n  color: var(--accent-primary, #3b82f6);\n}\n\n.admin-modal .admin-modal-actions .admin-modal-btn-submit {\n  background: linear-gradient(180deg, #3b82f6 0%, #2563eb 100%);\n  color: #fff;\n  border: none;\n  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.35);\n}\n\n.admin-modal .admin-modal-actions .admin-modal-btn-submit:hover:not(:disabled) {\n  background: linear-gradient(180deg, #2563eb 0%, #1d4ed8 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.4);\n}\n\n.admin-modal .admin-modal-actions .admin-modal-btn-submit:focus-visible {\n  outline: 2px solid #93c5fd;\n  outline-offset: 2px;\n}\n\n.admin-modal .admin-modal-actions .admin-modal-btn-cancel:focus-visible {\n  outline: 2px solid var(--accent-primary, #3b82f6);\n  outline-offset: 2px;\n}\n\n[data-theme='dark'] .admin-modal .admin-modal-actions .admin-modal-btn-cancel {\n  background: rgba(30, 41, 59, 0.9);\n  border-color: rgba(148, 163, 184, 0.25);\n  color: var(--text-primary, #f1f5f9);\n}\n\n[data-theme='dark'] .admin-modal .admin-modal-actions .admin-modal-btn-cancel:hover:not(:disabled) {\n  border-color: #60a5fa;\n  color: #93c5fd;\n}\n\n.admin-card {\n  display: flex;\n  gap: 14px;\n  padding: 18px;\n  border-radius: 16px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.admin-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-md);\n}\n\n.admin-card .card-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-primary);\n  flex-shrink: 0;\n}\n\n.admin-card.accent-blue .card-icon {\n  background: rgba(79, 70, 229, 0.15);\n  color: #4F46E5;\n  box-shadow: none;\n}\n\n.admin-card.accent-purple .card-icon {\n  background: rgba(124, 58, 237, 0.15);\n  color: #7c3aed;\n  box-shadow: none;\n}\n\n.admin-card.accent-green .card-icon {\n  background: rgba(16, 185, 129, 0.15);\n  color: #10b981;\n  box-shadow: none;\n}\n\n.card-body {\n  display: grid;\n  gap: 8px;\n}\n\n.card-title {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.card-text {\n  color: var(--text-secondary);\n  font-size: 0.96rem;\n}\n\n.card-link {\n  font-weight: 700;\n  color: var(--accent-color);\n  font-size: 0.95rem;\n}\n\n.admin-columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 18px;\n}\n\n.admin-panel {\n  background: var(--bg-secondary);\n  border-radius: 14px;\n  border: 1px solid var(--border-color);\n  padding: 20px;\n  box-shadow: var(--shadow-sm);\n  width: 100%;\n}\n\n.panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.panel-label {\n  color: #94a3b8;\n  font-size: 0.8rem;\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.panel-title {\n  margin: 4px 0 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.pill {\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.pill-green {\n  background: rgba(16, 185, 129, 0.12);\n  color: #10b981;\n}\n\n.pill-blue {\n  background: rgba(59, 130, 246, 0.12);\n  color: #2563eb;\n}\n\n.panel-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 10px;\n}\n\n.panel-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n  background: var(--bg-primary);\n}\n\n.item-title {\n  margin: 0;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.item-text {\n  margin: 4px 0 0;\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n}\n\n.item-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.status-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-flex;\n}\n\n.status-dot.success {\n  background: #22c55e;\n}\n\n.status-dot.warning {\n  background: #f59e0b;\n}\n\n.status-dot.info {\n  background: #3b82f6;\n}\n\n.health-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.health-card {\n  border-radius: 12px;\n  padding: 12px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n.health-card .item-title {\n  font-size: 0.98rem;\n}\n\n.health-value {\n  margin: 6px 0;\n  font-size: 1.5rem;\n  font-weight: 800;\n}\n\n.health-card .metric-trend {\n  margin-top: 4px;\n}\n\n.health-card.tone-blue .health-value {\n  color: #2563eb;\n}\n\n.health-card.tone-purple .health-value {\n  color: #7c3aed;\n}\n\n.health-card.tone-green .health-value {\n  color: #059669;\n}\n\n.updates {\n  border-top: 1px solid rgba(226, 232, 240, 0.9);\n  padding-top: 12px;\n}\n\n.updates-title {\n  margin: 0 0 8px;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.updates-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 10px;\n}\n\n.updates-item {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 12px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n}\n\n.item-badge {\n  align-self: center;\n  padding: 6px 10px;\n  border-radius: 10px;\n  background: rgba(79, 70, 229, 0.15);\n  color: #4F46E5;\n  font-weight: 700;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 1024px) {\n  .admin-hero {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Category Stats Styles */\n.category-stats-container {\n  margin-top: 12px;\n}\n\n.admin-category-stats-bento {\n  overflow: visible;\n}\n\n.admin-category-stats-bento .admin-category-stats-panel {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  padding: 8px 8px 4px;\n}\n\n.category-stats-chart-stack {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  width: 100%;\n}\n\n.category-stats-full-list {\n  width: 100%;\n  max-width: 560px;\n}\n\n.category-stats-full-list-heading {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: var(--text-secondary, #64748b);\n  margin: 0 0 12px;\n  text-align: center;\n}\n\n.category-stats-full-list-ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.category-stats-full-list-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  border-radius: 10px;\n  background: var(--bg-primary, #fff);\n  border: 1px solid var(--border-color, rgba(226, 232, 240, 0.85));\n}\n\n.category-stats-full-list-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.06);\n}\n\n.category-stats-full-list-name {\n  flex: 1;\n  min-width: 0;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary, #1e293b);\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.category-stats-full-list-count {\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: var(--accent-color, #6366f1);\n  flex-shrink: 0;\n  font-variant-numeric: tabular-nums;\n}\n\n.category-stats-donut-wrap--interactive {\n  cursor: crosshair;\n}\n\n.category-stats-donut-tooltip {\n  pointer-events: none;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: #1e293b;\n  color: #f8fafc;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.35);\n  max-width: 260px;\n}\n\n.category-stats-donut-tooltip-title {\n  font-weight: 700;\n  font-size: 0.88rem;\n  margin-bottom: 4px;\n  color: #fff;\n  line-height: 1.3;\n}\n\n.category-stats-donut-tooltip-count {\n  font-size: 0.78rem;\n  color: #94a3b8;\n}\n\n.category-stats-donut-wrap {\n  position: relative;\n  width: 200px;\n  height: 200px;\n  flex-shrink: 0;\n}\n\n.category-stats-donut-ring {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  box-shadow: 0 8px 28px rgba(99, 102, 241, 0.2);\n}\n\n.category-stats-donut-ring--empty {\n  background: conic-gradient(#e2e8f0 0% 100%);\n  opacity: 0.85;\n}\n\n.category-stats-donut-hole {\n  position: absolute;\n  inset: 18%;\n  border-radius: 50%;\n  background: linear-gradient(160deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid rgba(226, 232, 240, 0.95);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 8px;\n  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.9);\n  pointer-events: none;\n}\n\n.category-stats-donut-total {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: #1e293b;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n}\n\n.category-stats-donut-label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-top: 4px;\n}\n\n.category-stats-legend {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  flex: 1;\n  min-width: 200px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.category-stats-legend-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid rgba(226, 232, 240, 0.85);\n}\n\n.category-stats-legend-swatch {\n  width: 12px;\n  height: 12px;\n  border-radius: 4px;\n  flex-shrink: 0;\n  margin-top: 4px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);\n}\n\n.category-stats-legend-title {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.category-stats-legend-meta {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #6366f1;\n}\n\n.category-stats-list {\n  display: grid;\n  gap: 10px;\n}\n\n.category-stat-item {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  padding: 14px 16px;\n  transition: all 0.25s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.category-stat-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 3px;\n  height: 100%;\n  background: var(--accent-color);\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n\n.category-stat-item:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-sm);\n  border-color: #3f3f46;\n}\n\n.category-stat-item:hover::before {\n  opacity: 1;\n}\n\n.category-stat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.category-stat-title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  flex: 1;\n  line-height: 1.4;\n}\n\n.category-stat-count {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--accent-color);\n  margin-left: 12px;\n}\n\n.category-stat-bar-container {\n  width: 100%;\n  height: 6px;\n  background: var(--bg-secondary);\n  border-radius: 999px;\n  overflow: hidden;\n  margin-bottom: 8px;\n  position: relative;\n}\n\n.category-stat-bar {\n  height: 100%;\n  background: var(--accent-color);\n  border-radius: 999px;\n  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: none;\n}\n\n.category-stat-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 0.8rem;\n}\n\n.category-stat-percentage {\n  font-weight: 700;\n  color: #475569;\n  font-size: 0.85rem;\n}\n\n.category-stat-label {\n  color: #94a3b8;\n  font-size: 0.8rem;\n}\n\n.category-stats-loading,\n.category-stats-error,\n.category-stats-empty {\n  padding: 32px 20px;\n  text-align: center;\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.category-stats-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.loading-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--border-color);\n  border-top-color: #6366f1;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.category-stats-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.error-message {\n  color: #ef4444;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 768px) {\n  .admin-page {\n    padding: 18px;\n  }\n\n  .admin-columns {\n    grid-template-columns: 1fr;\n  }\n\n  .panel-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .item-meta {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .category-stat-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .category-stat-count {\n    font-size: 0.9rem;\n  }\n\n  /* =========================================\n   NEW ADMIN DASHBOARD STYLES (CHARTS & FORM)\n   ========================================= */\n\n  /* Header Actions */\n  .admin-header-actions {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n\n  .admin-header-actions .orders-pager-nav {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 16px;\n    border-radius: 8px;\n  }\n\n  .admin-quick-metrics {\n    display: flex;\n    gap: 12px;\n    margin-right: 8px;\n  }\n\n  .metric-badge-blue {\n    color: var(--accent-primary, #2563eb) !important;\n    background: rgba(37, 99, 235, 0.1) !important;\n    border: none !important;\n    padding: 6px 12px !important;\n  }\n\n  .metric-badge-blue i,\n  .metric-badge-blue svg {\n    margin-right: 6px;\n  }\n\n  .metric-badge-green {\n    color: var(--accent-success, #10b981) !important;\n    background: rgba(16, 185, 129, 0.1) !important;\n    border: none !important;\n    padding: 6px 12px !important;\n  }\n\n  .metric-badge-green i,\n  .metric-badge-green svg {\n    margin-right: 6px;\n  }\n\n  /* Expandable Form */\n  .admin-form-panel {\n    background: var(--bg-secondary, #ffffff);\n    border: 1px solid var(--border-color, #e5e7eb);\n    border-radius: 12px;\n    padding: 20px;\n    margin-top: 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);\n  }\n\n  .admin-form-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 16px;\n  }\n\n  .admin-form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .admin-form-group label {\n    font-size: 0.8rem;\n    font-weight: 700;\n    color: var(--text-secondary, #64748b);\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n  }\n\n  .admin-form-group input,\n  .admin-form-group select {\n    width: 100%;\n    padding: 10px 14px;\n    border-radius: 8px;\n    border: 1px solid var(--border-color, #cbd5e1);\n    background: var(--bg-primary, #ffffff);\n    font-size: 0.95rem;\n    color: var(--text-primary);\n    outline: none;\n    transition: all 0.2s ease;\n    box-sizing: border-box;\n  }\n\n  .admin-form-group input:focus,\n  .admin-form-group select:focus {\n    border-color: var(--accent-primary, #2563eb);\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n  }\n\n  .admin-form-actions {\n    margin-top: 20px;\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  /* Charts Grid */\n  .admin-charts-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));\n    gap: 24px;\n    padding-bottom: 24px;\n  }\n\n  .admin-chart-card {\n    background: var(--bg-secondary, #ffffff);\n    border-radius: 16px;\n    padding: 24px;\n    border: 1px solid var(--border-color, #e5e7eb);\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);\n    display: flex;\n    flex-direction: column;\n  }\n\n  .admin-chart-title {\n    margin: 0 0 24px 0;\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: var(--text-primary);\n  }\n\n  .admin-chart-container {\n    width: 100%;\n    height: 320px;\n  }\n\n  /* Custom Recharts Tooltip */\n  .admin-chart-tooltip {\n    background: var(--bg-secondary, #ffffff) !important;\n    padding: 12px 16px !important;\n    border: 1px solid var(--border-color, #e5e7eb) !important;\n    border-radius: 8px !important;\n    box-shadow: 0 4px 12px -2px rgba(0, 0, 0, 0.08) !important;\n  }\n\n  .admin-chart-tooltip .tooltip-title {\n    margin: 0;\n    font-weight: 600;\n    color: var(--text-primary);\n    font-size: 0.95rem;\n  }\n\n  .admin-chart-tooltip .tooltip-value {\n    margin: 4px 0 0;\n    font-size: 0.9rem;\n  }\n\n  .admin-chart-tooltip .tooltip-value span {\n    font-weight: 700;\n  }\n\n  @media (max-width: 768px) {\n    .admin-header-actions {\n      flex-direction: column;\n      align-items: stretch;\n    }\n\n    .admin-charts-grid {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n/* Updated Status Metrics Card */\n.admin-status-card-new {\n  background: var(--bg-glass-heavy);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  border: 1px solid var(--border-glass);\n  border-radius: 20px;\n  padding: 16px;\n  width: 100%;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.admin-status-card-new .status-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.admin-status-card-new .status-row .custom-icon {\n  color: var(--accent-primary);\n  opacity: 0.9;\n  flex-shrink: 0;\n  /* Prevent icon from shrinking */\n}\n\n.admin-status-card-new .status-label {\n  font-family: var(--font-heading);\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  flex: 1;\n}\n\n.admin-status-card-new .status-value {\n  font-family: var(--font-data);\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  text-align: right;\n  white-space: nowrap;\n  /* Prevent value from wrapping */\n}\n\n.admin-status-card-new .status-divider {\n  height: 1px;\n  width: 100%;\n  border-top: 1px dashed var(--border-color);\n  opacity: 0.3;\n}\n\n[data-theme='dark'] .admin-status-card-new .status-divider {\n  opacity: 0.15;\n}\n\n/* Global Page Entry Animation */\n.user-details-page {\n  animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Disable hover effects for Create Employee tab as requested */\n.admin-create-employee-card:hover {\n  transform: none !important;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.03) !important;\n}\n\n.admin-create-employee-card .btn:hover {\n  transform: none !important;\n}\n\n/* Sidebar Metrics Alignment & Spacing */\n.profile-sidebar-metrics {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 16px;\n  width: 100%;\n}\n\n/* Premium Form Styles */\n.premium-form-card {\n  box-shadow: 0 10px 30px -5px rgba(0, 0, 0, 0.05);\n}\n\n.card-content-rows {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-row-premium {\n  display: flex;\n  flex-direction: column;\n  padding: 16px 24px;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.4);\n}\n\n.form-row-premium.horizontal {\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.row-label-caps {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  width: 140px;\n  flex-shrink: 0;\n}\n\n.row-value-right {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.premium-input-minimal {\n  width: 100%;\n  background: rgba(248, 250, 252, 0.6);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  padding: 10px 14px 10px 40px;\n  border-radius: 12px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  outline: none;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.premium-input-minimal:focus {\n  background: white;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);\n}\n\n.admin-create-employee-card .premium-input-wrapper:not(.premium-input-wrapper--password-toggle) .premium-input-minimal {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.btn-premium-action-new {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 14px 32px;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 14px;\n  font-weight: 700;\n  font-size: 1rem;\n  cursor: pointer;\n  overflow: hidden;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);\n}\n\n.btn-premium-action-new:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.35);\n  background: #2563eb;\n}\n\n.btn-premium-action-new:active {\n  transform: translateY(0);\n}\n\n.btn-premium-action-new:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);\n}\n\n.btn-inner-glow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n}\n\n.form-grid-premium {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n}\n\n.form-group-premium {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group-premium.full-width {\n  grid-column: span 2;\n}\n\n.premium-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.premium-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n/* Высота строки как у .premium-select-trigger (12px по вертикали), глаз компактнее и чуть ниже оптического центра как у стрелки роли */\n.premium-input-wrapper--password-toggle .premium-input-minimal {\n  padding: 12px 44px 12px 40px;\n}\n\n.premium-input-wrapper--password-toggle .password-toggle {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(calc(-50% + 2px));\n  color: #94a3b8;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: color 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n}\n\n.premium-input-wrapper--password-toggle .password-toggle:hover {\n  color: var(--text-main);\n}\n\n.premium-input-icon {\n  position: absolute;\n  left: 14px;\n  color: var(--text-secondary);\n  opacity: 0.5;\n  transition: all 0.3s ease;\n  pointer-events: none;\n}\n\n.premium-input {\n  width: 100%;\n  padding: 12px 16px 12px 42px !important;\n  border-radius: 12px !important;\n  border: 1px solid var(--border-glass) !important;\n  background: var(--bg-glass-light) !important;\n  backdrop-filter: blur(8px);\n  font-size: 1rem;\n  color: var(--text-primary);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.premium-input:focus {\n  border-color: var(--accent-primary) !important;\n  background: var(--bg-glass-heavy) !important;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1) !important;\n}\n\n.premium-input:focus + .premium-input-icon {\n  color: var(--accent-primary);\n  opacity: 1;\n}\n\n/* Premium Select Styles */\n.premium-select-container {\n  position: relative;\n  width: 100%;\n}\n\n.premium-select-trigger {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background: rgba(248, 250, 252, 0.5);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  color: var(--text-primary);\n}\n\n.premium-select-trigger:hover {\n  background: white;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);\n}\n\n.trigger-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-weight: 600;\n}\n\n.arrow-icon {\n  transition: transform 0.3s ease;\n}\n\n.arrow-icon.rotate {\n  transform: rotate(180deg);\n}\n\n.premium-select-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  right: 0;\n  background: var(--bg-glass-heavy);\n  backdrop-filter: blur(20px);\n  border: 1px solid var(--border-glass);\n  border-radius: 14px;\n  box-shadow: var(--shadow-lg);\n  z-index: 100;\n  overflow: hidden;\n  padding: 6px;\n}\n\n.premium-select-option {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: none;\n  background: transparent;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.premium-select-option:hover {\n  background: rgba(59, 130, 246, 0.1);\n}\n\n.premium-select-option.active {\n  background: var(--accent-primary);\n  color: white;\n}\n\n.option-text {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.option-label {\n  font-weight: 700;\n  font-size: 0.95rem;\n}\n\n.option-desc {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.form-actions-premium {\n  margin-top: 32px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.btn-premium-submit {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 32px !important;\n  border-radius: 14px !important;\n  font-weight: 700 !important;\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;\n}\n\n.btn-premium-submit:hover {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.3) !important;\n}\n\n/* ==========================================================\n   ADMIN MOBILE ADAPTATION\n   ========================================================== */\n@media (max-width: 1024px) {\n  .admin-dashboard-root .user-profile-dashboard,\n  .admin-dashboard-root .user-profile-dashboard.no-stats {\n    grid-template-columns: 1fr !important;\n    gap: 12px !important;\n  }\n\n  .admin-dashboard-root .profile-sidebar,\n  .admin-dashboard-root .profile-stats-sidebar {\n    position: static !important;\n    top: auto !important;\n    width: 100%;\n    max-width: 100%;\n    /* Без этого элемент как grid-item наследует min-width:auto и растягивает\n       общую 1fr-колонку по содержимому (строке вкладок), несмотря на\n       overflow-x:auto у .sidebar-nav — классический CSS Grid blowout. */\n    min-width: 0;\n  }\n\n  .admin-dashboard-root .profile-sidebar {\n    padding: 14px;\n    border-radius: 14px;\n    gap: 12px;\n  }\n\n  .admin-dashboard-root .sidebar-header {\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    text-align: left;\n    gap: 10px;\n    padding-bottom: 0;\n  }\n\n  .admin-dashboard-root .sidebar-avatar-placeholder {\n    width: 46px !important;\n    height: 46px !important;\n    margin-bottom: 0 !important;\n  }\n\n  .admin-dashboard-root .sidebar-nav {\n    flex-direction: row;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    gap: 8px;\n    padding-bottom: 4px;\n  }\n\n  .admin-dashboard-root .sidebar-nav::-webkit-scrollbar {\n    display: none;\n  }\n\n  .admin-dashboard-root .nav-tab-side {\n    width: auto;\n    min-width: max-content;\n    flex: 0 0 auto;\n    padding: 9px 12px;\n    border-radius: 10px;\n  }\n\n  .admin-dashboard-root .user-profile-dashboard .bento-grid-layout {\n    grid-template-columns: 1fr !important;\n    gap: 10px !important;\n  }\n\n  .admin-dashboard-root .bento-large,\n  .admin-dashboard-root .bento-medium,\n  .admin-dashboard-root .bento-small {\n    grid-column: span 1 !important;\n  }\n\n  .admin-dashboard-root .admin-chart-slot {\n    height: 280px !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .admin-dashboard-root .profile-dashboard-main {\n    gap: 12px !important;\n  }\n\n  .admin-dashboard-root .bento-card {\n    border-radius: 14px;\n  }\n\n  .admin-dashboard-root .card-header {\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n\n  .admin-dashboard-root .period-selector {\n    width: 100%;\n    justify-content: flex-start;\n    overflow-x: auto;\n    scrollbar-width: none;\n  }\n\n  .admin-dashboard-root .period-selector::-webkit-scrollbar {\n    display: none;\n  }\n\n  .admin-dashboard-root .admin-notifications-top-grid,\n  .admin-dashboard-root .admin-notifications-meta-row,\n  .admin-dashboard-root .admin-notifications-technical-grid {\n    grid-template-columns: 1fr !important;\n  }\n\n  .admin-dashboard-root .admin-notifications-header-actions {\n    width: 100%;\n    justify-items: stretch;\n  }\n\n  .admin-dashboard-root .admin-notifications-save-pill {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .admin-dashboard-root .form-row-premium.horizontal {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n    padding: 12px 14px;\n  }\n\n  .admin-dashboard-root .row-label-caps {\n    width: 100%;\n    font-size: 0.7rem;\n    letter-spacing: 0.04em;\n  }\n\n  .admin-dashboard-root .row-value-right {\n    justify-content: stretch;\n  }\n\n  .admin-dashboard-root .row-value-right > * {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .admin-dashboard-root .profile-sidebar,\n  .admin-dashboard-root .bento-card,\n  .admin-dashboard-root .admin-modal {\n    border-radius: 12px;\n  }\n\n  .admin-dashboard-root .profile-sidebar {\n    padding: 12px;\n  }\n\n  .admin-dashboard-root .nav-tab-side {\n    padding: 8px 10px;\n    font-size: 0.82rem;\n  }\n\n  .admin-dashboard-root .admin-chart-slot {\n    height: 240px !important;\n  }\n\n  .admin-dashboard-root .admin-modal {\n    padding: 14px;\n  }\n\n  .admin-dashboard-root .admin-modal .admin-modal-actions {\n    flex-direction: column;\n  }\n\n  .admin-dashboard-root .admin-modal .admin-modal-actions .admin-modal-btn-cancel,\n  .admin-dashboard-root .admin-modal .admin-modal-actions .admin-modal-btn-submit {\n    width: 100%;\n  }\n}\n\n/* Promo codes tab */\n.admin-promo-codes {\n  width: 100%;\n}\n\n.admin-promo-layout {\n  grid-template-columns: minmax(0, 1fr) !important;\n}\n\n.admin-promo-card {\n  max-width: 960px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.admin-promo-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 24px 24px 16px;\n}\n\n.admin-promo-title {\n  margin: 0;\n}\n\n.admin-promo-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.admin-promo-refresh-btn {\n  min-width: 44px;\n  padding: 10px 12px;\n}\n\n.admin-promo-banner {\n  margin: 0 24px 12px;\n}\n\n.admin-promo-create-form {\n  overflow: hidden;\n  border-top: 1px solid var(--border-color, rgba(148, 163, 184, 0.2));\n}\n\n.admin-promo-select {\n  width: 100%;\n  max-width: 400px;\n  cursor: pointer;\n}\n\n.admin-promo-list-wrap {\n  padding: 8px 24px 24px;\n}\n\n.admin-promo-muted {\n  color: var(--text-secondary);\n  margin: 12px 0;\n}\n\n.admin-tx-link-cell {\n  cursor: pointer;\n  color: var(--accent-primary);\n  font-weight: 600;\n}\n\n.admin-tx-link-cell:hover {\n  text-decoration: underline;\n}\n\n/* ── Итоги по выборке транзакций ── */\n.admin-tx-summary {\n  padding: 20px 24px;\n}\n\n.admin-tx-summary-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 12px;\n}\n\n.admin-tx-summary-card {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  background: var(--bg-secondary);\n  min-width: 0;\n}\n\n.admin-tx-summary-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-secondary);\n}\n\n.admin-tx-summary-value {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  word-break: break-word;\n}\n\n.admin-tx-summary-card--credit .admin-tx-summary-label {\n  color: #16a34a;\n}\n\n.admin-tx-summary-card--debit .admin-tx-summary-label {\n  color: #dc2626;\n}\n\n.admin-tx-summary-bytype {\n  margin-top: 16px;\n}\n\n.admin-tx-summary-bytype-title {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-secondary);\n}\n\n.admin-tx-summary-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.admin-tx-summary-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  background: var(--bg-secondary);\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n\n.admin-tx-summary-chip-value {\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n/* ── Чекбокс в мультивыборе ── */\n.multi-select-box {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  border-radius: 4px;\n  border: 1.5px solid var(--border-color, rgba(148, 163, 184, 0.5));\n  color: #fff;\n}\n\n.multi-select-box.checked {\n  background: var(--accent-primary);\n  border-color: var(--accent-primary);\n}\n\n.admin-promo-table-wrap {\n  overflow-x: auto;\n  border-radius: 12px;\n  border: 1px solid rgba(148, 163, 184, 0.2);\n}\n\n.admin-promo-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n}\n\n.admin-promo-table th,\n.admin-promo-table td {\n  padding: 12px 14px;\n  text-align: left;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.15);\n}\n\n.admin-promo-table th {\n  font-weight: 700;\n  color: var(--text-secondary);\n  font-size: 0.78rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: rgba(148, 163, 184, 0.06);\n}\n\n.admin-promo-table tbody tr {\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.admin-promo-table tbody tr:hover {\n  background: rgba(99, 102, 241, 0.06);\n}\n\n.admin-promo-table tbody tr.selected {\n  background: rgba(99, 102, 241, 0.12);\n}\n\n.admin-promo-code {\n  font-weight: 700;\n  color: var(--text-primary);\n  background: rgba(139, 92, 246, 0.1);\n  padding: 2px 8px;\n  border-radius: 6px;\n}\n\n.admin-promo-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n.admin-promo-badge.active {\n  background: rgba(16, 185, 129, 0.15);\n  color: #059669;\n}\n\n.admin-promo-badge.inactive {\n  background: rgba(148, 163, 184, 0.15);\n  color: var(--text-secondary);\n}\n\n.admin-promo-detail {\n  margin: 0 24px 24px;\n  padding: 20px;\n  border-radius: 14px;\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  background: rgba(255, 255, 255, 0.4);\n}\n\n.admin-promo-detail-title {\n  margin: 0 0 16px;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.admin-promo-detail-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.admin-promo-detail-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px 20px;\n}\n\n.admin-promo-detail-row--edit {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.admin-promo-detail-label {\n  min-width: 140px;\n  font-size: 0.82rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-secondary);\n}\n\n.admin-promo-edit-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n}\n\n.admin-promo-edit-row .premium-input-minimal {\n  flex: 1;\n  min-width: 200px;\n}\n\n.admin-promo-save-btn {\n  white-space: nowrap;\n}\n\n.admin-promo-toggle {\n  border: none;\n  border-radius: 10px;\n  padding: 8px 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.admin-promo-toggle.on {\n  background: rgba(239, 68, 68, 0.12);\n  color: #dc2626;\n}\n\n.admin-promo-toggle.off {\n  background: rgba(16, 185, 129, 0.12);\n  color: #059669;\n}\n\n.admin-promo-toggle:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.admin-promo-stats-section,\n.admin-promo-users-section {\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(148, 163, 184, 0.2);\n}\n\n.admin-promo-section-title {\n  margin: 0 0 14px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.admin-promo-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n@media (max-width: 640px) {\n  .admin-promo-stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-promo-stat-card {\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  background: rgba(255, 255, 255, 0.5);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.admin-promo-stat-label {\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-secondary);\n}\n\n.admin-promo-stat-value {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--text-primary);\n}\n\n.admin-promo-users-table tbody tr {\n  cursor: default;\n}\n\n.admin-promo-users-table tbody tr:hover {\n  background: rgba(148, 163, 184, 0.06);\n}\n\n.admin-promo-user-link {\n  color: #6366f1;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.admin-promo-user-link:hover {\n  text-decoration: underline;\n}\n\n.admin-promo-pagination {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.admin-promo-pagination-info {\n  font-size: 0.88rem;\n  color: var(--text-secondary);\n}\n\n/* Promo codes — list page */\n.admin-promo-list-page {\n  width: 100%;\n}\n\n.admin-promo-list-shell {\n  max-width: 1100px;\n  margin: 0 auto;\n  background: rgba(255, 255, 255, 0.72);\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.06);\n}\n\n.admin-promo-list-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 24px 24px 16px;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.15);\n}\n\n.admin-promo-list-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 800;\n  color: var(--text-primary);\n}\n\n.admin-promo-list-title-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: rgba(139, 92, 246, 0.12);\n  color: #8b5cf6;\n}\n\n.admin-promo-list-subtitle {\n  margin: 6px 0 0;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.admin-promo-create-collapse {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  border-bottom: 1px solid transparent;\n}\n\n.admin-promo-create-collapse.is-open {\n  grid-template-rows: 1fr;\n  border-bottom-color: rgba(148, 163, 184, 0.15);\n}\n\n.admin-promo-create-collapse-inner {\n  min-height: 0;\n  overflow: hidden;\n  opacity: 0;\n  transition: opacity 0.15s ease;\n  pointer-events: none;\n}\n\n.admin-promo-create-collapse.is-open .admin-promo-create-collapse-inner {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.admin-promo-create-panel {\n  border-bottom: none;\n}\n\n.admin-promo-create-panel-inner {\n  padding: 20px 24px 24px;\n}\n\n.admin-promo-create-panel-title {\n  margin: 0 0 16px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.admin-promo-create-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n\n@media (max-width: 900px) {\n  .admin-promo-create-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-promo-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.admin-promo-field-label {\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-secondary);\n}\n\n.admin-promo-create-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n.admin-promo-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 16px 24px;\n  background: rgba(148, 163, 184, 0.05);\n  border-bottom: 1px solid rgba(148, 163, 184, 0.12);\n}\n\n.admin-promo-search-wrap {\n  position: relative;\n  flex: 1;\n  min-width: 220px;\n  max-width: 420px;\n}\n\n.admin-promo-search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-secondary);\n  pointer-events: none;\n}\n\n.admin-promo-search-input {\n  width: 100%;\n  padding: 11px 40px 11px 42px;\n  border-radius: 12px;\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  background: #fff;\n  font-size: 0.92rem;\n  color: var(--text-primary);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.admin-promo-search-input:focus {\n  outline: none;\n  border-color: rgba(99, 102, 241, 0.5);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);\n}\n\n.admin-promo-search-clear {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n\n.admin-promo-search-clear:hover {\n  background: rgba(148, 163, 184, 0.12);\n  color: var(--text-primary);\n}\n\n.admin-promo-results-count {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.admin-promo-list-body {\n  padding: 8px 0 0;\n}\n\n.admin-promo-list-empty {\n  padding: 32px 24px;\n  text-align: center;\n}\n\n.admin-promo-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 48px 24px;\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n.admin-promo-empty-state p {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n.admin-promo-table-wrap--list {\n  border: none;\n  border-radius: 0;\n}\n\n.admin-promo-table--list tbody tr.admin-promo-table-row-link:focus-visible {\n  outline: 2px solid rgba(99, 102, 241, 0.5);\n  outline-offset: -2px;\n}\n\n.admin-promo-table-date {\n  font-size: 0.86rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.admin-promo-table-col-action {\n  width: 44px;\n  text-align: right;\n}\n\n.admin-public-file-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin-promo-row-chevron {\n  color: rgba(148, 163, 184, 0.7);\n  transition: transform 0.15s ease, color 0.15s ease;\n}\n\n.admin-promo-table-row-link:hover .admin-promo-row-chevron {\n  color: #6366f1;\n  transform: translateX(2px);\n}\n\n.admin-promo-badge.large {\n  padding: 6px 14px;\n  font-size: 0.85rem;\n}\n\n.admin-promo-hero-status {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin-promo-hero-status-edit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  flex-shrink: 0;\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.85);\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;\n}\n\n.admin-promo-hero-status-edit:hover:not(:disabled) {\n  border-color: rgba(99, 102, 241, 0.4);\n  color: #6366f1;\n  background: #fff;\n}\n\n.admin-promo-hero-status-edit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Promo codes — detail page */\n.admin-promo-detail-page {\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.admin-promo-confirm-title {\n  margin: 0;\n  font-size: 1.1rem;\n  color: var(--text-primary);\n}\n\n.admin-promo-confirm-subtitle {\n  margin: 0 0 12px;\n  color: var(--text-secondary);\n}\n\n.admin-promo-confirm-body .form-status.error {\n  margin-top: 12px;\n}\n\n.admin-promo-page-card {\n  padding: 22px 24px;\n  border-radius: 16px;\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  background: rgba(255, 255, 255, 0.72);\n  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.04);\n}\n\n.admin-promo-detail-hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n  padding: 24px;\n  border-radius: 16px;\n  border: 1px solid rgba(139, 92, 246, 0.2);\n  background: linear-gradient(135deg, rgba(139, 92, 246, 0.08) 0%, rgba(99, 102, 241, 0.04) 100%);\n}\n\n.admin-promo-detail-hero-main {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.admin-promo-detail-hero-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: rgba(139, 92, 246, 0.15);\n  color: #7c3aed;\n}\n\n.admin-promo-detail-hero-code {\n  margin: 0;\n  font-size: 1.6rem;\n  font-weight: 800;\n}\n\n.admin-promo-detail-hero-code code {\n  background: transparent;\n  padding: 0;\n  font-size: inherit;\n  color: var(--text-primary);\n}\n\n.admin-promo-detail-hero-meta {\n  margin: 6px 0 0;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n.admin-promo-detail-hero-dot {\n  margin: 0 6px;\n}\n\n.admin-promo-detail-alert {\n  margin-bottom: 16px;\n}\n\n.admin-promo-detail-layout {\n  display: grid;\n  grid-template-columns: 1.2fr 0.8fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 860px) {\n  .admin-promo-detail-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-promo-card-heading {\n  margin: 0 0 18px;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.admin-promo-users-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.admin-promo-users-header .admin-promo-card-heading {\n  margin: 0;\n}\n\n.admin-promo-users-card {\n  margin-top: 0;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .admin-promo-create-collapse,\n  .admin-promo-create-collapse-inner,\n  .admin-promo-table tbody tr,\n  .admin-promo-row-chevron,\n  .admin-promo-search-input {\n    transition: none !important;\n  }\n}\n\n/* ============================================================\n   News banners tab\n   ============================================================ */\n.admin-banner-title-icon {\n  background: rgba(59, 130, 246, 0.12);\n  color: #2563eb;\n}\n\n.admin-banner-create-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.admin-banner-editor-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 18px;\n  align-items: stretch;\n}\n\n@media (max-width: 900px) {\n  .admin-banner-editor-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-banner-html-field {\n  min-width: 0;\n}\n\n.admin-banner-html-input {\n  min-height: 190px;\n  resize: vertical;\n  font-family: 'SFMono-Regular', ui-monospace, 'JetBrains Mono', Menlo, Consolas, monospace;\n  font-size: 0.82rem;\n  line-height: 1.5;\n  tab-size: 2;\n  white-space: pre;\n  overflow-wrap: normal;\n}\n\n.admin-banner-preview-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.admin-banner-preview-box {\n  position: relative;\n  flex: 1;\n  min-height: 380px;\n  border: 1px dashed rgba(148, 163, 184, 0.4);\n  border-radius: 12px;\n  background:\n    linear-gradient(45deg, rgba(148, 163, 184, 0.06) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.06) 75%) 0 0 / 16px 16px,\n    linear-gradient(45deg, rgba(148, 163, 184, 0.06) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.06) 75%) 8px 8px / 16px 16px,\n    #ffffff;\n  padding: 14px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-banner-preview-box--modal {\n  flex: none;\n  height: 440px;\n  min-height: 0;\n  margin-bottom: 6px;\n}\n\n/* Инлайн phone-превью: рамка телефона 390×800 масштабируется JS-ом так, чтобы\n   баннер целиком вписался в бокс (letterbox), как в детальном просмотре. */\n.admin-banner-phone-stage {\n  position: absolute;\n  inset: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n.admin-banner-phone-frame {\n  flex: 0 0 auto;\n  transform-origin: center center;\n  border-radius: 26px;\n  overflow: hidden;\n  background: #ffffff;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);\n}\n.admin-banner-phone-iframe {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  display: block;\n  pointer-events: none;\n}\n\n.admin-banner-preview-content {\n  width: 100%;\n}\n\n.admin-banner-preview-content img {\n  max-width: 100%;\n  height: auto;\n}\n\n.admin-banner-preview-empty {\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  opacity: 0.75;\n  text-align: center;\n}\n\n/* Isolated preview: the pasted document (its html/body/global <style>) renders\n   inside a sandboxed iframe so it can never restyle the admin page. */\n.admin-banner-preview-frame {\n  width: 100%;\n  height: 320px;\n  border: 0;\n  border-radius: 8px;\n  background: #ffffff;\n  display: block;\n  pointer-events: none;\n}\n.admin-banner-preview-box--modal .admin-banner-preview-frame {\n  height: 180px;\n}\n.admin-banner-card-preview .admin-banner-preview-frame {\n  height: 100px;\n  border-radius: 0;\n}\n\n/* Corner button that opens the zoomable detail view. */\n.admin-banner-zoom-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  background: rgba(255, 255, 255, 0.92);\n  color: #475569;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, transform 0.05s ease;\n}\n.admin-banner-zoom-btn:hover {\n  background: #ffffff;\n  color: #0f172a;\n}\n.admin-banner-zoom-btn:active {\n  transform: scale(0.94);\n}\n\n/* Zoom modal ------------------------------------------------------------- */\n/* Portaled to <body>; z-index sits above the fixed navbar (1000) and the other\n   admin overlays so its toolbar is never clipped. */\n.admin-banner-zoom-backdrop {\n  z-index: 4000;\n  padding: 24px;\n}\n.admin-banner-zoom {\n  display: flex;\n  flex-direction: column;\n  width: min(760px, 100%);\n  height: min(88vh, 920px);\n  background: #ffffff;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.35);\n}\n.admin-banner-zoom-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.2);\n}\n.admin-banner-zoom-name {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: #0f172a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.admin-banner-zoom-controls {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.admin-banner-zoom-ctrl,\n.admin-banner-zoom-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: 1px solid rgba(148, 163, 184, 0.3);\n  background: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.admin-banner-zoom-ctrl:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n.admin-banner-zoom-ctrl:hover:not(:disabled),\n.admin-banner-zoom-close:hover {\n  background: rgba(148, 163, 184, 0.12);\n}\n.admin-banner-zoom-close {\n  margin-left: 6px;\n}\n.admin-banner-zoom-pct {\n  min-width: 58px;\n  height: 34px;\n  padding: 0 8px;\n  border-radius: 8px;\n  border: 1px solid rgba(148, 163, 184, 0.3);\n  background: #ffffff;\n  color: #0f172a;\n  font-weight: 600;\n  font-size: 0.82rem;\n  cursor: pointer;\n}\n.admin-banner-zoom-stage {\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  padding: 20px;\n  background:\n    linear-gradient(45deg, rgba(148, 163, 184, 0.09) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.09) 75%) 0 0 / 18px 18px,\n    linear-gradient(45deg, rgba(148, 163, 184, 0.09) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.09) 75%) 9px 9px / 18px 18px,\n    #f1f5f9;\n}\n.admin-banner-zoom-sizer {\n  margin: auto;\n  flex: 0 0 auto;\n}\n.admin-banner-zoom-frame-wrap {\n  transform-origin: top left;\n}\n.admin-banner-zoom-frame {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  border-radius: 14px;\n  background: #ffffff;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);\n}\n\n.admin-banner-dates-grid {\n  grid-template-columns: 1fr 1fr;\n}\n\n@media (max-width: 640px) {\n  .admin-banner-dates-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-banner-registered-hint {\n  grid-column: 1 / -1;\n  margin-top: -2px;\n}\n\n.admin-banner-audience-field {\n  gap: 10px;\n}\n\n.admin-banner-audience-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n}\n\n@media (max-width: 640px) {\n  .admin-banner-audience-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.admin-banner-audience-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 10px 12px;\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.7);\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.admin-banner-audience-pill:hover {\n  border-color: rgba(59, 130, 246, 0.4);\n  color: #2563eb;\n}\n\n.admin-banner-audience-pill.active {\n  border-color: transparent;\n  background: linear-gradient(135deg, #3b82f6 0%, #6366f1 100%);\n  color: #fff;\n  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.25);\n}\n\n.admin-banner-ids-input {\n  margin-top: 10px;\n  min-height: 70px;\n  resize: vertical;\n  font-family: 'SFMono-Regular', ui-monospace, Menlo, Consolas, monospace;\n  font-size: 0.8rem;\n}\n\n.admin-banner-hint {\n  display: block;\n  margin-top: 6px;\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n}\n\n/* Cards list */\n.admin-banner-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  gap: 16px;\n  padding: 4px 2px;\n}\n\n@media (max-width: 640px) {\n  .admin-banner-cards {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-banner-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.85);\n  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.05);\n  overflow: hidden;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;\n}\n\n.admin-banner-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.1);\n  border-color: rgba(99, 102, 241, 0.28);\n}\n\n.admin-banner-card-preview {\n  position: relative;\n  max-height: 130px;\n  overflow: hidden;\n  padding: 14px;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.15);\n  background:\n    linear-gradient(45deg, rgba(148, 163, 184, 0.05) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.05) 75%) 0 0 / 14px 14px,\n    #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-banner-card-preview .admin-banner-preview-content img {\n  max-width: 100%;\n  height: auto;\n}\n\n.admin-banner-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px 16px;\n  flex: 1;\n}\n\n.admin-banner-card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.admin-banner-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 11px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n}\n\n.admin-banner-badge.all {\n  background: rgba(100, 116, 139, 0.14);\n  color: #475569;\n}\n\n.admin-banner-badge.customer {\n  background: rgba(16, 185, 129, 0.14);\n  color: #059669;\n}\n\n.admin-banner-badge.provider {\n  background: rgba(245, 158, 11, 0.16);\n  color: #d97706;\n}\n\n.admin-banner-badge.users {\n  background: rgba(139, 92, 246, 0.14);\n  color: #7c3aed;\n}\n\n.admin-banner-live-dot {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.74rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.admin-banner-live-dot .dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #cbd5e1;\n}\n\n.admin-banner-live-dot.live {\n  color: #059669;\n}\n\n.admin-banner-live-dot.live .dot {\n  background: #10b981;\n  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.18);\n}\n\n.admin-banner-card-snippet {\n  margin: 0;\n  font-size: 0.88rem;\n  line-height: 1.45;\n  color: var(--text-primary);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.admin-banner-card-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: auto;\n}\n\n.admin-banner-meta-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n}\n\n.admin-banner-card-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 10px 16px;\n  border-top: 1px solid rgba(148, 163, 184, 0.15);\n  background: rgba(248, 250, 252, 0.6);\n}\n\n.admin-banner-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  border-radius: 9px;\n  background: #fff;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;\n}\n\n.admin-banner-icon-btn:hover {\n  border-color: rgba(59, 130, 246, 0.4);\n  color: #2563eb;\n}\n\n.admin-banner-icon-btn.danger:hover {\n  border-color: rgba(239, 68, 68, 0.45);\n  color: #dc2626;\n  background: rgba(239, 68, 68, 0.05);\n}\n\n/* Edit modal */\n.admin-banner-edit-modal {\n  max-width: 560px;\n  width: 100%;\n  max-height: 92vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.admin-banner-edit-modal .modal-header,\n.admin-banner-edit-modal .admin-modal-actions {\n  flex-shrink: 0;\n}\n\n.admin-banner-edit-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.admin-banner-edit-note {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .admin-banner-card,\n  .admin-banner-audience-pill,\n  .admin-banner-icon-btn {\n    transition: none !important;\n  }\n}\n/* ============================================================\n   ТЁМНАЯ ТЕМА (роль DEV) — точечные переопределения admin.css.\n   Здесь собраны места, где фон брался из токена (в тёмной теме\n   становится тёмным), а цвет текста/иконки был захардкожен светлым\n   значением — из-за чего в тёмной теме текст сливался или карточка\n   оставалась белой. Значения подобраны так, чтобы контраст был\n   комфортным (>= AA для текста).\n   ============================================================ */\n\n/* Плашки-статусы: синий текст был слишком тёмным на тёмном фоне */\n:root[data-theme='dark'] .pill-blue {\n  color: #93c5fd;\n}\n\n/* Форма уведомлений и общие поля формы */\n:root[data-theme='dark'] .admin-notifications-form .form-field textarea,\n:root[data-theme='dark'] .admin-notifications-result-title,\n:root[data-theme='dark'] .admin-notifications-open-page-select {\n  color: var(--text-primary);\n}\n\n:root[data-theme='dark'] .admin-notifications-result-text,\n:root[data-theme='dark'] .admin-notifications-platform-item,\n:root[data-theme='dark'] .form-field,\n:root[data-theme='dark'] .modal-body,\n:root[data-theme='dark'] .category-stat-percentage {\n  color: var(--text-secondary);\n}\n\n:root[data-theme='dark'] .admin-notifications-save-pill-text {\n  color: #bae6fd;\n}\n\n:root[data-theme='dark'] .admin-notifications-save-pill-hint {\n  color: #7dd3fc;\n}\n\n:root[data-theme='dark'] .updates-title {\n  color: var(--text-primary);\n}\n\n/* Иконки и значения на карточках-статистики — подсветлены */\n:root[data-theme='dark'] .admin-card.accent-blue .card-icon {\n  background: rgba(129, 140, 248, 0.18);\n  color: #a5b4fc;\n}\n\n:root[data-theme='dark'] .admin-card.accent-purple .card-icon {\n  background: rgba(167, 139, 250, 0.18);\n  color: #c4b5fd;\n}\n\n:root[data-theme='dark'] .health-card.tone-blue .health-value {\n  color: #60a5fa;\n}\n\n:root[data-theme='dark'] .health-card.tone-purple .health-value {\n  color: #a78bfa;\n}\n\n:root[data-theme='dark'] .health-card.tone-green .health-value {\n  color: #34d399;\n}\n\n:root[data-theme='dark'] .item-badge {\n  color: #a5b4fc;\n}\n\n/* CategoryStats: пончик и легенда были белыми карточками */\n:root[data-theme='dark'] .category-stats-donut-hole {\n  background: linear-gradient(160deg, #273449 0%, #1e293b 100%);\n  border-color: var(--border-color);\n  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.04);\n}\n\n:root[data-theme='dark'] .category-stats-donut-total {\n  color: var(--text-heading);\n}\n\n:root[data-theme='dark'] .category-stats-donut-ring--empty {\n  background: conic-gradient(#334155 0% 100%);\n}\n\n:root[data-theme='dark'] .category-stats-legend-item {\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n}\n\n:root[data-theme='dark'] .category-stats-legend-title {\n  color: var(--text-primary);\n}\n\n:root[data-theme='dark'] .category-stats-legend-meta {\n  color: #a5b4fc;\n}\n\n/* Промокоды / баннеры: инпуты и кнопки-чипы становились белыми */\n:root[data-theme='dark'] .admin-promo-search-input,\n:root[data-theme='dark'] .admin-banner-icon-btn {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n:root[data-theme='dark'] .admin-promo-hero-status-edit:hover:not(:disabled),\n:root[data-theme='dark'] .premium-input-minimal:focus,\n:root[data-theme='dark'] .premium-select-trigger:hover {\n  background: var(--bg-tertiary);\n}\n\n:root[data-theme='dark'] .admin-banner-badge.all {\n  color: var(--text-secondary);\n}\n\n/* Модалка увеличенного превью баннера: тёмная «обвязка»,\n   при этом само полотно баннера (.admin-banner-zoom-frame) и\n   мокап телефона остаются белыми — это реальный холст контента. */\n:root[data-theme='dark'] .admin-banner-zoom {\n  background: var(--bg-card);\n}\n\n:root[data-theme='dark'] .admin-banner-zoom-name,\n:root[data-theme='dark'] .admin-banner-zoom-pct {\n  color: var(--text-primary);\n}\n\n:root[data-theme='dark'] .admin-banner-zoom-ctrl,\n:root[data-theme='dark'] .admin-banner-zoom-close,\n:root[data-theme='dark'] .admin-banner-zoom-pct {\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n}\n\n:root[data-theme='dark'] .admin-banner-zoom-ctrl:hover:not(:disabled),\n:root[data-theme='dark'] .admin-banner-zoom-close:hover {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n:root[data-theme='dark'] .admin-banner-zoom-stage {\n  background:\n    linear-gradient(45deg, rgba(148, 163, 184, 0.06) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.06) 75%) 0 0 / 18px 18px,\n    linear-gradient(45deg, rgba(148, 163, 184, 0.06) 25%, transparent 25%, transparent 75%, rgba(148, 163, 184, 0.06) 75%) 9px 9px / 18px 18px,\n    #0b1120;\n}\n\n/* ============================================================\n   Тёмная тема: промокоды / баннеры / формы — оставались белыми.\n   Настоящие «холсты» контента (превью баннера, рамка телефона,\n   iframe-превью, zoom-frame) намеренно НЕ трогаем — они белые,\n   потому что это реальная поверхность рендера баннера.\n   ============================================================ */\n\n/* Внешний «холст» обеих вкладок (промокоды и баннеры) */\n:root[data-theme='dark'] .admin-promo-list-shell {\n  background: var(--bg-secondary);\n  border-color: var(--border-color);\n}\n\n/* Внутренние панели/карточки промокодов */\n:root[data-theme='dark'] .admin-promo-detail,\n:root[data-theme='dark'] .admin-promo-stat-card,\n:root[data-theme='dark'] .admin-promo-page-card {\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n}\n\n:root[data-theme='dark'] .admin-promo-hero-status-edit {\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n  color: var(--text-secondary);\n}\n\n/* Поля ввода и триггер селекта (форма сотрудника + создание промокода) */\n:root[data-theme='dark'] .premium-input-minimal,\n:root[data-theme='dark'] .premium-select-trigger {\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n  color: var(--text-primary);\n}\n\n/* Баннеры: карточки списка, «таблетки» аудитории, панель действий */\n:root[data-theme='dark'] .admin-banner-card {\n  background: var(--bg-secondary);\n  border-color: var(--border-color);\n}\n\n:root[data-theme='dark'] .admin-banner-card-actions {\n  background: var(--bg-tertiary);\n  border-top-color: var(--border-color);\n}\n\n:root[data-theme='dark'] .admin-banner-audience-pill {\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n  color: var(--text-secondary);\n}\n\n:root[data-theme='dark'] .admin-banner-audience-pill:hover {\n  border-color: rgba(96, 165, 250, 0.45);\n  color: #93c5fd;\n}\n\n:root[data-theme='dark'] .admin-banner-audience-pill.active {\n  background: rgba(59, 130, 246, 0.22);\n  border-color: rgba(96, 165, 250, 0.55);\n  color: #dbeafe;\n  box-shadow: 0 0 0 1px rgba(96, 165, 250, 0.25) inset;\n}\n\n/* ── Маркетплейс (DEV) ── */\n.admin-mkt-title-icon {\n  background: rgba(59, 130, 246, 0.12);\n  color: #3b82f6;\n}\n\n/* Переключатель разделов: Сервисы / Покупки */\n.admin-mkt-tabs {\n  display: flex;\n  gap: 8px;\n  padding: 18px 24px 16px;\n  margin-bottom: 0;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.12);\n  flex-wrap: wrap;\n}\n\n.admin-mkt-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: 999px;\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n}\n\n.admin-mkt-tab:hover {\n  color: var(--text-primary);\n  border-color: rgba(59, 130, 246, 0.4);\n}\n\n.admin-mkt-tab.active {\n  background: rgba(59, 130, 246, 0.12);\n  border-color: rgba(59, 130, 246, 0.5);\n  color: #3b82f6;\n}\n\n.admin-mkt-tab-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: rgba(59, 130, 246, 0.18);\n  color: #3b82f6;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n/* Иконка сервиса */\n.admin-mkt-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  object-fit: cover;\n  line-height: 1;\n}\n\n.admin-mkt-icon--empty,\n.admin-mkt-icon--text {\n  background: rgba(148, 163, 184, 0.14);\n  color: var(--text-secondary);\n}\n\n.admin-mkt-col-icon {\n  width: 56px;\n}\n\n.admin-public-file-thumb {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n.admin-public-file-url {\n  max-width: 420px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.admin-mkt-col-actions {\n  width: 96px;\n  text-align: right;\n}\n\n.admin-mkt-row-actions {\n  display: inline-flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.admin-mkt-cell-title {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.admin-mkt-cell-desc {\n  max-width: 320px;\n  color: var(--text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.admin-mkt-cell-price {\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n/* Карточки сервисов (в стиле карточек баннеров) */\n.admin-mkt-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 16px;\n  padding: 20px 24px 24px;\n}\n\n@media (max-width: 640px) {\n  .admin-mkt-cards {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-mkt-card {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.85);\n  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.05);\n  overflow: hidden;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;\n}\n\n.admin-mkt-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.1);\n  border-color: rgba(59, 130, 246, 0.28);\n}\n\n.admin-mkt-card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 16px 0;\n}\n\n.admin-mkt-card-head .admin-mkt-icon {\n  border-radius: 14px;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);\n}\n\n.admin-mkt-card-price {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: rgba(16, 185, 129, 0.12);\n  color: #059669;\n  font-size: 0.9rem;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.admin-mkt-card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 16px 14px;\n  flex: 1;\n}\n\n.admin-mkt-card-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.3;\n}\n\n.admin-mkt-card-desc {\n  margin: 0;\n  font-size: 0.86rem;\n  line-height: 1.45;\n  color: var(--text-secondary);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-height: 2.5em;\n}\n\n.admin-mkt-card-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: auto;\n  padding-top: 4px;\n}\n\n.admin-mkt-meta-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n}\n\n.admin-mkt-card-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 10px 16px;\n  border-top: 1px solid rgba(148, 163, 184, 0.15);\n  background: rgba(248, 250, 252, 0.6);\n}\n\n.admin-mkt-hint {\n  display: block;\n  margin-top: 4px;\n  font-size: 0.72rem;\n  color: var(--text-secondary);\n}\n\n.admin-mkt-desc-field {\n  margin-top: 4px;\n}\n\n/* В форме сервиса общих полей два — иконка и цена */\n.admin-mkt-form-grid {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n@media (max-width: 900px) {\n  .admin-mkt-form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Мультиязычный блок формы сервиса: вкладки RO / RU / EN */\n.admin-mkt-lang-block {\n  margin-top: 12px;\n  padding: 12px;\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  border-radius: 12px;\n  background: rgba(248, 250, 252, 0.5);\n}\n\n.admin-mkt-lang-tabs {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.admin-mkt-lang-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n}\n\n.admin-mkt-lang-tab:hover:not(:disabled) {\n  color: var(--text-primary);\n  border-color: rgba(59, 130, 246, 0.4);\n}\n\n.admin-mkt-lang-tab.active {\n  background: rgba(59, 130, 246, 0.12);\n  border-color: rgba(59, 130, 246, 0.5);\n  color: #3b82f6;\n}\n\n.admin-mkt-lang-tab:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Точка-индикатор: заполнено ли название на этом языке */\n.admin-mkt-lang-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: rgba(148, 163, 184, 0.55);\n}\n\n.admin-mkt-lang-dot.filled {\n  background: #22c55e;\n}\n\n.admin-mkt-lang-field {\n  margin-top: 10px;\n}\n\n:root[data-theme='dark'] .admin-mkt-lang-block {\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n}\n\n:root[data-theme='dark'] .admin-mkt-lang-tab {\n  border-color: var(--border-color);\n}\n\n.admin-mkt-desc-input {\n  resize: vertical;\n  min-height: 70px;\n  font-family: inherit;\n}\n\n/* Статусы покупок */\n.admin-mkt-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.admin-mkt-status--open {\n  background: rgba(245, 158, 11, 0.15);\n  color: #d97706;\n}\n\n.admin-mkt-status--in-progress {\n  background: rgba(59, 130, 246, 0.15);\n  color: #2563eb;\n}\n\n.admin-mkt-status--closed {\n  background: rgba(16, 185, 129, 0.15);\n  color: #059669;\n}\n\n/* Статистика покупок */\n.admin-mkt-stats-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding: 20px 24px 4px;\n}\n\n/* Тулбар покупок (счётчик + сортировка) */\n.admin-mkt-purchases-toolbar {\n  background: transparent;\n  border-bottom: none;\n  padding: 12px 24px 16px;\n}\n\n/* Тулбар покупок теперь первый блок в разделе (счётчик покупок убрали) —\n   возвращаем стандартный вид тулбара, как у сервисов. */\n.admin-mkt-purchases-toolbar--first {\n  background: rgba(148, 163, 184, 0.05);\n  border-bottom: 1px solid rgba(148, 163, 184, 0.12);\n  padding: 16px 24px;\n}\n\n/* Выпадашка сортировки покупок (2 колонки: поле сортировки + направление).\n   Раньше была 360px — слишком узко, подписи вроде «По дате» переносились\n   на две строки. */\n.admin-mkt-sort-dropdown {\n  width: 460px;\n  min-width: 460px;\n  max-width: calc(100vw - 16px);\n}\n\n@media (max-width: 640px) {\n  .admin-mkt-sort-dropdown {\n    width: calc(100vw - 16px);\n    min-width: 0;\n  }\n}\n\n/* Отступы стандартного пейджера (orders-pager) внутри маркетплейса —\n   такой же, как в поиске пользователей/заказов, но с горизонтальным полем\n   вровень с остальными блоками карточки-шелла. */\n.admin-marketplace .orders-pager {\n  padding: 12px 24px 20px;\n  margin: 0;\n}\n\n.admin-mkt-stat-card {\n  display: inline-flex;\n  align-items: center;\n  gap: 16px;\n  min-width: 240px;\n  padding: 18px 24px;\n  border-radius: 16px;\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  background: rgba(255, 255, 255, 0.85);\n  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.05);\n}\n\n.admin-mkt-stat-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #3b82f6, #6366f1);\n  color: #fff;\n  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.32);\n}\n\n.admin-mkt-stat-body {\n  display: flex;\n  flex-direction: column;\n}\n\n.admin-mkt-stat-value {\n  font-size: 1.5rem;\n  font-weight: 800;\n  line-height: 1.1;\n  color: var(--text-primary);\n}\n\n.admin-mkt-stat-label {\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n}\n\n.admin-mkt-edit-modal .admin-mkt-form-grid,\n.admin-mkt-edit-body .admin-promo-create-grid {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n:root[data-theme='dark'] .admin-mkt-tab {\n  border-color: var(--border-color);\n}\n\n:root[data-theme='dark'] .admin-mkt-stat-card {\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n}\n\n:root[data-theme='dark'] .admin-mkt-icon--empty,\n:root[data-theme='dark'] .admin-mkt-icon--text {\n  background: var(--bg-secondary);\n}\n\n:root[data-theme='dark'] .admin-mkt-card {\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n}\n\n:root[data-theme='dark'] .admin-mkt-card:hover {\n  border-color: rgba(96, 165, 250, 0.4);\n}\n\n:root[data-theme='dark'] .admin-mkt-card-actions {\n  background: rgba(255, 255, 255, 0.02);\n  border-top-color: var(--border-color);\n}\n\n:root[data-theme='dark'] .admin-mkt-card-price {\n  background: rgba(16, 185, 129, 0.18);\n  color: #34d399;\n}\n\n/* ── Админка без внутренней колонки вкладок (разделы в общем сайдбаре) ── */\n.admin-dashboard-root .user-profile-dashboard.no-side {\n  grid-template-columns: 1fr 240px !important;\n}\n\n.admin-dashboard-root .user-profile-dashboard.no-side.no-stats {\n  grid-template-columns: 1fr !important;\n}\n\n@media (max-width: 1100px) {\n  .admin-dashboard-root .user-profile-dashboard.no-side {\n    grid-template-columns: 1fr !important;\n  }\n}\n\n.admin-page-head {\n  grid-column: 1 / -1;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 4px;\n}\n\n.admin-page-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  flex: 0 0 44px;\n  border-radius: 13px;\n  background: var(--bg-tertiary, rgba(148, 163, 184, 0.14));\n  color: var(--accent-primary, #2563eb);\n}\n\n.admin-page-title {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--text-heading, var(--text-primary));\n}\n\n.admin-page-sub {\n  margin: 2px 0 0;\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
